/*
 *###############################################################################
 *Module Name                   : ProductMaster.js                          #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Wednesday, September 8th 2021, 2:11:27 pm     #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState, useEffect, useContext } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane, Alert
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPNavBar from "../../../framework/widgets/DPNavBar"
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPInfoBox from "../../../framework/layout/DPInfoBox"
//Import Tabs
import ProductGenContent from "./ProductGenContent"
import ProductStatusContent from "../Product-Master/ProductStatusContent"
import ProductRefContent from "../Product-Master/ProductRefContent"
import ProductGroupContent from "../Product-Master/ProductGroupContent"
import ProductSupplierContent from "../Product-Master/ProductSupplierContent"
import ProductPriceContent from "../Product-Master/ProductPriceContent"
import ProductBarcodeContent from "./ProductBarcodeContent"
import ProductTaxContent from "./ProductTaxContent"
import ProductInventoryContent from "./ProductInventoryContent"
import ProductImageContent from "./ProductImageContent"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import DPSearchBox from 'framework/components/DPSearchBox'
import ProductVarientContent from "./ProductVarientContent"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation" // Textbox input validations
//Import Product master Api method
import {
  setProductSave,
  getProductDetailsCode,
  setProductTempSave,
  getLocationDets,
  getGroupSummary, getProInventory, getUploadValidation, getAvailableStock, getCommonName, getLocationsUserWise, handleUploadProducts,
  getCustomerTax,
  getAllLocations,
  GetProductDefaultLocations
} from "./ProductController"
//Import Product default image
import Noimage from "assets/images/product/noimage.jpg"
import DPPrintOption from "framework/widgets/DPPrintOptions"
import moment from "moment"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import ProductAutoOrderContent from "./ProductAutoOrderContent"
import ProductPriceChanges from "./ProductPriceChanges"
import DPProductExcelUploadPopUp from "framework/components/DPProductExcelUploadPopUp"
import { ProductCustomerBarcode } from "./ProductCustomerBarcode"
import { ProductDefaultLocation } from "./ProductDefaultLocation"
import ProductSupplierFreeQty from "./ProductSupplierFreeQty"

const photovalues = {
  imageSrc: Noimage,
  imageFile: null,
  imagepath: null,
}
const ProductMaster = props => {

  const productCodeID = props.location.search.replace("?", "")

  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  const ReportURL = window.Links.ReportURL

  const date = new Date()
  const today = moment(date).format("YYYY-MM-DD")

  let history = useHistory();

  //import from contexts
  const {
    isHeadOffice, getMenuDetails, txnDecimalAmt, txnDecimalQty, masterAuditLog, getSelectedMasterPermissions, fetchProductAutoCode, addtoFavourite, calGP_WithTAX,
    validate_groups, default_markup, excludefrom_productreset, proSup_default_loc, validateWeighted_VS_MP, validateProductImage
  } = useContext(Context);


  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [saveEnable, setSaveEnable] = useState(true)
  const [DataTables, SetDatatable] = useState([])
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [AlertShow, setAlertShow] = useState(false)
  const [AlertColor, setAlertColor] = useState("")
  const [AlertMsg, setAlertMsg] = useState("")
  const [menuCode, SetMenuCode] = useState("")

  const [disabled, setDisabled] = useState(false)
  const [picture, setPicture] = useState(photovalues);
  const [imgName, setImgName] = useState("")

  const [strReason, setReason] = useState("Created")
  const [ErrorMsg, setErrorMsg] = useState('')
  const [deleteEnable, SetDeleteEnable] = useState(false)

  //**Set Values of the controls of  General Tab (Tab==1) */
  const [strProductCode, SetProductCode] = useState("")
  const [blProductCodeEnable, SetProductCodeEnable] = useState(false)
  const [strProductDesc, SetProductDesc] = useState("")
  const [blProductDescEnable, SetProductDescEnable] = useState(false)
  const [strProductPOSDesc, SetProductPOSDesc] = useState("")
  const [blProductPOSDescEnable, SetProductPOSDescEnable] = useState(false)
  const [strProductTouchDesc, SetProductTouchDesc] = useState("")
  const [blProductTouchDescEnable, SetProductTouchDescEnable] = useState(false)
  const [strStockCode, SetStockCode] = useState("")
  const [blStockCodeEnable, SetStockCodeEnable] = useState(false)
  const [strVendorPLU, SetVendorPLU] = useState("")
  const [blVendorPLUEnable, SetVendorPLUEnable] = useState(false)
  const [strUnit, SetUnit] = useState("")
  const [blUnitEnable, SetUnitnable] = useState(false)
  const [strPurchase, SetPurchase] = useState("")
  const [blPurchaseEnable, SetPurchasenable] = useState(false)
  const [strLanguage1, SetLanguage1] = useState("")
  const [blLanguage1Enable, SetLanguage1enable] = useState(false)
  const [strLanguage2, SetLanguage2] = useState("")
  const [blLanguage2Enable, SetLanguage2enable] = useState(false)
  const [strCasesize, SetCasesize] = useState("1")
  const [blCasesizeEnable, SetCasesizeenable] = useState(false)
  const [dbCost, SetCost] = useState(parseFloat(0).toFixed(2))
  const [previousCost, setPreviousCost] = useState(0)
  const [blCostEnable, SetCostenable] = useState(false)
  const [dbMarkup, SetMarkup] = useState(parseFloat(default_markup).toFixed(2))
  const [blMarkupEnable, SetMarkupenable] = useState(false)
  const [dbSelling, SetSelling] = useState(parseFloat(0).toFixed(2))
  const [previousSelling, setPreviousSelling] = useState(0)
  const [blSellingEnable, SetSellingenable] = useState(false)
  const [dbPackPrice, SetPackPrice] = useState(parseFloat(0).toFixed(2))
  const [blPackPriceEnable, SetPackPriceenable] = useState(false)
  const [dbAVGCost, SetAVGCost] = useState(parseFloat(0).toFixed(2))
  const [blAVGCostEnable, SetAVGCostenable] = useState(true)
  const [dbFixedGP, SetFixedGP] = useState(parseFloat(0).toFixed(2))
  const [blFixedGPEnable, SetFixedGPenable] = useState(false)
  const [dbCurrGP, SetCurrGP] = useState(parseFloat(0).toFixed(2))
  const [blCurrGPEnable, SetCurrGPenable] = useState(true)
  const [dbMaxDicPer, SetMaxDicPer] = useState(parseFloat(0).toFixed(2))
  const [blMaxDicPerEnable, SetMaxDicPerenable] = useState(false)
  const [dbrMaxDicAmt, SetMaxDicAmt] = useState(parseFloat(0).toFixed(2))
  const [blMaxDicAmtEnable, SetMaxDicAmtenable] = useState(false)
  const [dbrMaxAllowQty, SetMaxAllowQty] = useState(parseFloat(0).toFixed(2))
  const [blMaxAllowQtyEnable, SetMaxAllowQtyenable] = useState(false)
  const [dbMinSell, SetMinSell] = useState(parseFloat(0).toFixed(2))

  const [proFormData, setProFormData] = useState({
    shortExpiryDays: 0
  })


  const [blPriceChanges, setPriceChanges] = useState(0)

  // Return/Emty Bottle
  const [strReturnCode, setReturnCode] = useState("")
  const [strReturnDescription, setReturnDescription] = useState("")
  const [return_modal_xlarge, setreturn_modal_xlarge] = useState(false)

  //**Set Values of the controls of  Status Tab (Tab==2) */
  const [blActive, SetActive] = useState(false)
  const [blActiveEnable, SetActiveEnable] = useState(false)
  const [blPosActive, SetPosActive] = useState(false)
  const [blPosActiveEnable, SetPosActiveEnable] = useState(false)
  const [backofficeActive, SetBackOfficeActive] = useState(false)
  const [blPurOrderEnable, SetPurOrderEnable] = useState(false)
  const [blOpen, SetOpen] = useState(false)
  const [blOpenEnable, SetOpenEnable] = useState(false)
  const [blComposite, SetComposite] = useState(false)
  const [blCompositeEnable, SetCompositeEnable] = useState(false)
  const [blWeighted, SetWeighted] = useState(false)
  const [blWeightedEnable, SetWeightedEnable] = useState(false)
  const [blExpiry, SetExpiry] = useState(false)
  const [blExpiryEnable, SetExpiryEnable] = useState(false)
  const [blDirectGRN, SetDirectGRN] = useState(false)
  const [blDirectGRNEnable, SetDirectGRNEnable] = useState(false)
  const [blSellingHo, SetSellingHo] = useState(false)
  const [blSellingHoEnable, SetSellingHoEnable] = useState(false)
  const [blfastmoving, Setfastmoving] = useState(false)
  const [blfastmovingEnable, SetfastmovingEnable] = useState(false)
  const [blRaw, SetRaw] = useState(false)
  const [blRawEnable, SetRawEnable] = useState(false)
  const [blPromotions, SetPromotions] = useState(false)
  const [blPromotionsEnable, SetPromotionsEnable] = useState(false)
  const [blMultiplePrices, SetMultiplePrices] = useState(false)
  const [blMultiplePricesEnable, SetMultiplePricesEnable] = useState(false)
  const [minusAllow, SetminusAllow] = useState(false)
  const [batchEnable, SetbatchEnable] = useState(false)
  const [varientEnable, SetvarientEnable] = useState(false)
  const [allowExchange, SetAllowExchange] = useState(false) //exchange switcher
  const [emptyBottle, setEmptyBottle] = useState(false)
  const [emptyBottleEnable, setEmptyBottleEnable] = useState(false)
  const [productionPOS, setProductionPOS] = useState(false)
  const [productionPOSDisable, setProductionPOSDisable] = useState(false)
  const [allowCostZero, setAllowCostZero] = useState(false)
  const [allowCostZeroDisable, setAllowCostZeroDisable] = useState(false)
  const [isCombineItem, setIsCombineItem] = useState(false)
  const [isCombineItemDisable, setIsCombineItemDisable] = useState(false)

  const [btnAutoActivation, setBtnAutoActivation] = useState([])

  //**Set Values of the controls of  References Tab (Tab==3) */
  const [strReference1, SetReference1] = useState("")
  const [blReference1Enable, SetReference1Enable] = useState(false)
  const [strReference2, SetReference2] = useState("")
  const [blReference2Enable, SetReference2Enable] = useState(false)
  const [strReference3, SetReference3] = useState("")
  const [blReference3Enable, SetReference3Enable] = useState(false)
  const [strReference4, SetReference4] = useState("")
  const [blReference4Enable, SetReference4Enable] = useState(false)
  const [strReference5, SetReference5] = useState("")
  const [blReference5Enable, SetReference5Enable] = useState(false)
  const [innerCaseSizes, setInnerCaseSizes] = useState([])

  //****User Activity Log Display related states*************************
  const [LogEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("") //Entry initially Created by
  const [mdBy, setMdBy] = useState("") //Entry Last Modified by
  const [crDate, setCrDate] = useState("") //Entry initially Created on
  const [mdDate, setMdDate] = useState("") //Entry last midified by
  //**End User Activity Log Display related states***********************


  const [locationPriceForm, setLocationPriceForm] = useState({
    searchPram: "",
    searchBy: "Loccode",
    placeHolder: "Search by Location",
  })

  //Varient tab usestes
  const [mergerItems, setMergerItems] = useState([{
    id: 1,
    proCode: "",
    code: "",
    name: "",
    variant1: "",
    variant2: "",
    cost: parseFloat(0).toFixed(2),
    avgCost: parseFloat(0).toFixed(2),
    reOrderlvl: "",
    reOrderQty: "",
    maxlvl: "",
    opBal: "",
    sih: 0,
    color: "",
    selling: parseFloat(0).toFixed(2),
    linkCost: parseFloat(0).toFixed(2),
  }])
  const [varient1apply, setVarient1apply] = useState(false)
  const [varient2apply, setVarient2apply] = useState(false)
  const [allColors, setAllColors] = useState([])
  const [allSizes, setAllSizes] = useState([])
  const [variant1name, setVariant1name] = useState("")
  const [variant2name, setVariant2name] = useState("")
  const [variantPNG, setVariantPNG] = useState("")
  const [PNGPath, setPNGPath] = useState(ReportURL + "Variants/Other.png")
  const [linkName, SetLinkName] = useState("")//Set Link Name state
  const [handleClearStatus, setHandleClearStatus] = useState(false)
  const [vatRate, setVatRate] = useState(0)


  //Multiple Price Tab usestates
  const [multiplePriceList, setMultiplePriceList] = useState([])


  const [arRow, setarRow] = useState([{ id: 1, code: '', taxCodeDisable: false, desc: '', state: true }])
  const [arRowSup, setarRowSupp] = useState([{
    id: 1,
    AfterMarkup: 0,
    Markup: 0,
    Cost: 0,
    Discount: 0,
    selling: 0,
    code: "",
    Loccode: "",
    state: false,
    desc: "",
    locationDisable: false,
    supplierDisable: true
  }])
  const [arRowPrice, setarRowPrice] = useState([{
    id: 1,
    Loccode: "",
    code: "",
    desc: "",
    StartDate: today,
    EndDate: today,
    StartQty: 0,
    EndQty: 0,
    DiscountPer: 0,
    DiscountAmt: 0,
    FixedPrice: 0,
    state: true,
    priceCodeDisable: true,
    supContribute: 0,
    comContribute: 0
  }])
  const [arRowBarcode, setarRowBarcode] = useState([{ id: 1, code: '', desc: '', RefNo: '', state: true }])
  const [AddNew, setAddNew] = useState(true)
  const [optionGroup, setoptionGroup1] = useState([])
  const [ProInventory, setoInventory] = useState([]) //inventory grid
  const [userWiseLocations, setUserWiseLocations] = useState([]) //user wise locations

  const [inventoryShow, setInventoryShow] = useState(false)

  const [freeQtyList, setFreeQtyList] = useState(
    [
      { supplier: "", supplierName: "", supplierDisable: false, qtyFrom: 0, qtyTo: 0, freeQty: 0 }
    ])

  //*****Menu Rights Start*/

  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [is_IR_user, setIs_IR_user] = useState(false)
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //show hide batch and varient
  const [showBatch, setShowBatch] = useState(false)
  const [showVarient, setShowVarient] = useState(false)


  //import from contexts
  var time = process.env.REACT_APP_ALERTTIMEOUT

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  const [valueUpload, setvalueUpload] = useState("")
  const [file, setFile] = useState(null)

  //**Get File Details */

  //Enable Disable Fields
  const [hideFields, setHideFields] = useState(false)
  const [proDescEnable, setProDescEnable] = useState(false)
  const [proPosDescDisable, setProPosDescDisable] = useState(false)
  const [proTouchDescDisable, setProTouchDescDisable] = useState(false)
  const [proStockDisable, setProStockDisable] = useState(false)
  const [proVendorDisable, setProVendorDisable] = useState(false)
  const [ProUnitDisable, setProUnitDisable] = useState(false)
  const [ProPurModeDisable, setProPurModeDisable] = useState(false)
  const [ProCSDisable, setProCSDisable] = useState(false)
  const [ProCostDisable, setProCostDisable] = useState(false)
  const [ProMarkupDisable, setProMarkupDisable] = useState(false)
  const [ProSellDisable, setProSellDisable] = useState(false)
  const [ProPackDisable, setProPackDisable] = useState(false)
  const [ProAVGDisable, setProAVGDisable] = useState(false)
  const [ProFixGPDisable, setProFixGPDisable] = useState(false)
  const [ProGPDisable, setProGPDisable] = useState(false)
  const [ProMaxDiscDisable, setProMaxDiscDisable] = useState(false)
  const [ProMaxDiscAmtDisable, setProMaxDiscAmtDisable] = useState(false)
  const [ProMaxAllowQtyDisable, setProMaxAllowQtyDisable] = useState(false)
  const [ProPictureDisable, setProPictureDisable] = useState(false)
  const [ProLan1Disable, setProLan1Disable] = useState(false)
  const [ProLan2Disable, setProLan2Disable] = useState(false)
  const [ProReturnDisable, setProReturnDisable] = useState(false)
  const [ProMinSellDisable, setProMinSellDisable] = useState(false)
  const [shortExpieryDisable, setShortExpieryDisable] = useState(false)

  const [ProActiveDisable, setProActiveDisable] = useState(false)
  const [ProPosActiveDisable, setProPosActiveDisable] = useState(false)
  const [ProOrderActiveDisable, setProOrderActiveDisable] = useState(false)
  const [ProOpenDisable, setProOpenDisable] = useState(false)
  const [ProBundleDisable, setProBundleDisable] = useState(false)
  const [ProDecimalDisable, setProDecimalDisable] = useState(false)
  const [ProExpDisable, setProExpDisable] = useState(false)
  const [ProDIRGRNDisable, setProDIRGRNDisable] = useState(false)
  const [ProHOPriceDisable, setProHOPriceDisable] = useState(false)
  const [ProFastMoveDisable, setProFastMoveDisable] = useState(false)
  const [ProRawItemDisable, setProRawItemDisable] = useState(false)
  const [ProNoDiscDisable, setProNoDiscDisable] = useState(false)
  const [ProMPDisable, setProMPDisable] = useState(false)
  const [ProMinusDisable, setProMinusDisable] = useState(false)
  const [ProAllowQTYDisable, setProAllowQTYDisable] = useState(false)
  const [ProAllowExchange, setProAloowExchange] = useState(false)
  const [emptyBottleDisable, setEmptyBottleDisable] = useState(false)

  const [ProRef1Disable, setProRef1Disable] = useState(false)
  const [ProRef2Disable, setProRef2Disable] = useState(false)
  const [ProRef3Disable, setProRef3Disable] = useState(false)
  const [ProRef4Disable, setProRef4Disable] = useState(false)
  const [ProRef5Disable, setProRef5Disable] = useState(false)

  const [GroupsDisable, setGroupsDisable] = useState([])

  const [excelSuccessResult, setExcelSuccessResult] = useState([])
  const [excelFailedResult, setExcelFailedResult] = useState([])
  const [toggleExcelUploadPopup, setToggleExcelUploadPopup] = useState(false)
  const [defaultLocations, setDefaultLocations] = useState([])

  //modal props for excel upload


  //TAB ACCESS RELATED USESTATES START
  // const [Tab1Access, setTab1Access] = useState(false)

  const [Tab1Create, setTab1Create] = useState(false)
  const [Tab2Create, setTab2Create] = useState(false)
  const [Tab3Create, setTab3Create] = useState(false)
  const [Tab4Create, setTab4Create] = useState(false)
  const [Tab5Create, setTab5Create] = useState(false)
  const [Tab6Create, setTab6Create] = useState(false)
  const [Tab7Create, setTab7Create] = useState(false)
  const [Tab8Create, setTab8Create] = useState(false)
  const [Tab9Create, setTab9Create] = useState(false)
  const [Tab10Create, setTab10Create] = useState(false)
  const [Tab11Create, setTab11Create] = useState(false)
  const [Tab12Create, setTab12Create] = useState(false)
  const [Tab13Create, setTab13Create] = useState(false)
  const [Tab14Create, setTab14Create] = useState(false)

  const [Tab1Modify, setTab1Modify] = useState(false)
  const [Tab2Modify, setTab2Modify] = useState(false)
  const [Tab3Modify, setTab3Modify] = useState(false)
  const [Tab4Modify, setTab4Modify] = useState(false)
  const [Tab5Modify, setTab5Modify] = useState(false)
  const [Tab6Modify, setTab6Modify] = useState(false)
  const [Tab7Modify, setTab7Modify] = useState(false)
  const [Tab8Modify, setTab8Modify] = useState(false)
  const [Tab9Modify, setTab9Modify] = useState(false)
  const [Tab10Modify, setTab10Modify] = useState(false)
  const [Tab11Modify, setTab11Modify] = useState(false)
  const [Tab12Modify, setTab12Modify] = useState(false)
  const [Tab13Modify, setTab13Modify] = useState(false)
  const [Tab14Modify, setTab14Modify] = useState(false)

  const [NewTabList, setNewTabList] = useState([])

  const [helpUrl, setHelpUrl] = useState("")

  var TabAccessNames = [
    {
      TabName: "Tab1",
      TabID: "1",
      // TabAccess: setTab1Access,
      TabCreate: setTab1Create,
      TabModify: setTab1Modify
    },
    {
      TabName: "Tab2",
      TabID: "2",
      TabCreate: setTab2Create,
      TabModify: setTab2Modify
    },
    {
      TabName: "Tab3",
      TabID: "3",
      TabCreate: setTab3Create,
      TabModify: setTab3Modify
    },
    {
      TabName: "Tab4",
      TabID: "4",
      TabCreate: setTab4Create,
      TabModify: setTab4Modify
    },
    {
      TabName: "Tab5",
      TabID: "5",
      TabCreate: setTab5Create,
      TabModify: setTab5Modify
    }
    ,
    {
      TabName: "Tab6",
      TabID: "6",
      TabCreate: setTab6Create,
      TabModify: setTab6Modify
    },
    {
      TabName: "Tab7",
      TabID: "7",
      TabCreate: setTab7Create,
      TabModify: setTab7Modify
    },
    {
      TabName: "Tab8",
      TabID: "8",
      TabCreate: setTab8Create,
      TabModify: setTab8Modify
    },
    {
      TabName: "Tab9",
      TabID: "9",
      TabCreate: setTab9Create,
      TabModify: setTab9Modify
    },
    {
      TabName: "Tab10",
      TabID: "10",
      TabCreate: setTab10Create,
      TabModify: setTab10Modify
    },
    {
      TabName: "Tab11",
      TabID: "11",
      TabCreate: setTab11Create,
      TabModify: setTab11Modify
    }, {
      TabName: "Tab12",
      TabID: "12",
      TabCreate: setTab12Create,
      TabModify: setTab12Modify
    }, {
      TabName: "Tab13",
      TabID: "13",
      TabCreate: setTab13Create,
      TabModify: setTab13Modify
    },
    {
      TabName: "Tab14",
      TabID: "14",
      TabCreate: setTab14Create,
      TabModify: setTab14Modify
    }
  ]


  //TAB ACCESS USESTATES END

  const [excelResult, setExcelResult] = useState(false)
  const columns = [{
    dataField: 'lineNo',
    text: 'Line No',
    sort: true,
  }, {
    dataField: 'description',
    text: 'Description',
    sort: true
  }, {
    dataField: 'refCode',
    text: 'Ref. Code',
    sort: true
  }, {
    dataField: 'remarks',
    text: 'Remarks',
    sort: true
  }, {
    dataField: 'status',
    text: 'Status',
    sort: true
  }];


  //import from contexts

  //default sorted method
  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  function excelTrigger() {
    setExcelResult(!excelResult)
    removeBodyCss()
  }

  function RemovePrice(index) {
    var temp = [...multiplePriceList]
    temp.splice(index, 1)
    setMultiplePriceList(temp)
  }

  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    const isIR = obj[10]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    setIs_IR_user(isIR == 1)



    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    fetch(`${ApiURL}PriceMode/linkwith`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    }).then(Response => Response.json())
      .then(responseData => {
        SetLinkName(responseData.data[0].name)
      }).catch(error =>
        console.log('error', error)
      );

    getAutoCodeFromAPI(menu)

  }, [])

  useEffect(async () => {
    if (productCodeID.length > 0) {
      ValueSetter(productCodeID)
    }

    const { success, data } = await getCustomerTax("VAT")
    if (success) {
      setVatRate(data.rate)
    }

    try {
      const locationResponse = await getAllLocations()
      const productDefaultLocations = await GetProductDefaultLocations()

      const updatedLocationList = locationResponse.map((item, index) => {
        const locationAvailable = productDefaultLocations.find((loc) => loc.value === item.value)
        if (locationAvailable) {
          return {
            ...item,
            checked: true,
            default: true,
            inInventory: false,
            index
          }
        } else {
          return {
            ...item,
            checked: false,
            default: false,
            inInventory: false,
            index
          }
        }
      })

      setDefaultLocations(updatedLocationList)
    } catch (error) {
      console.log(error)
    }

  }, [])



  useEffect(() => {
    let valGP = CalculateCurrentGP(dbSelling, dbCost, strCasesize)
    SetCurrGP(parseFloat(valGP, 10).toFixed(2))
  }, [arRow])


  useEffect(() => {

    SetMarkup(parseFloat(default_markup).toFixed(2))

    resetProSupplierWithDefaultLocation(proSup_default_loc)


  }, [default_markup, proSup_default_loc])


  /* 
  1. I have created an array of objects which contains the tab names and functions.
  2. I have created a dynamic tab list where I push the tab names which are allowed to access 
  3. I have created a loop where I call the API to get the tab access list and then I also call the functions to set the tab access
  4. When I set the dynamic tab list, it works for the first time but when I refresh the page or call the API again, the tab list is not updated. 
  */

  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName

    var requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: 'follow'
    };


    async function getTabAccess() {

      SetLoadingAlerttitle("UI Loading...")
      SetLoadingAlert(true)

      const dynamicTabList = [];
      const promises = TabAccessNames.map(async (tabAccess, index) => {
        const response = await fetch(`${ApiURL}login/menu/${LogUserType}/${menu}-${index + 1}`, requestOptions);
        const result = await response.json();

        // tabAccess.TabAccess(result.data.strMenuAccessRight);
        tabAccess.TabCreate(result.data.strMenuCreateRight);
        tabAccess.TabModify(result.data.strMenuModifyRight);

        //const iconName = index == 1 ? "fas fa-home" : index == 2 ? "fas fa-user" : index == 3 ? "fas fa-plus" : index == 4 ? "fas fa-plus" : index == 5 ? "fas fa-file-import" : index == 6 ? "fas fa-file-export" : index == 7 ? "fas fa-print" : index == 8 ? "fas fa-list" : index == 9 ? "" : index == 10 ? "fas fa-tools" : index == 11 ? "fas fa-wrench" : index == 12 ? "fas fa-cog" : ""

        if (result.data.strMenuAccessRight) {
          dynamicTabList.push({
            text: result.data.strMenuName,
            icon: "fas fa-home",
            tabID: tabAccess.TabID,
            onClick: () => {
              toggleCustom(tabAccess.TabID);
            },
          });
        }
      });

      await Promise.all(promises); // Wait for all fetch requests to complete

      dynamicTabList.push({
        text: "Default Location",
        icon: "fas fa-star",
        tabID: "15",
        onClick: () => {
          toggleCustom("15");
        },
      });

      dynamicTabList.sort((a, b) => a.tabID - b.tabID);

      setNewTabList(dynamicTabList);

    }

    getTabAccess()
  }, [])



  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu =
      menuDetail && menuDetail.menuTag
        ? menuDetail.menuTag
        : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log


    async function getVariantnames() {

      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        redirect: 'follow'
      };

      fetch(`${ApiURL}login/menu/${LogUserType}/M00607`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setVariant1name(result.data.strMenuName)
        }).catch(error =>
          console.log('error', error)
        );

      fetch(`${ApiURL}login/menu/${LogUserType}/M00606`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setVariant2name(result.data.strMenuName)
        }).catch(error =>
          console.log('error', error)
        );
    }

    async function getVariantBatch() {

      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        redirect: 'follow'
      };

      fetch(`${ApiURL}Common/getBatchVarinat`, requestOptions)
        .then(response => response.json())
        .then(result => {
          var dt = result.data[0]

          setShowVarient(dt.variant == true)
          setShowBatch(dt.batch == true)

        }).catch(error =>
          console.log('error', error)
        );

    }

    async function getNonEditable() {

      var requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        redirect: 'follow'
      };

      await fetch(`${ApiURL}Common/edit/${menu}`, requestOptions)
        .then(response => response.json())
        .then(result => {

          var dt = result.data[0]
          var newlist = dt != "" ? dt.strEditFeild.split(",") : []
          var groups = []
          var ActiveStatus = dt != "" ? dt.strActiveFields.split(",") : []

          setHideFields(dt.edt_hidefields)

          if (newlist.includes("PLU_DESC")) {
            setProDescEnable(true)
          }
          if (newlist.includes("PLU_POSDESC")) {
            setProPosDescDisable(true)
          }
          if (newlist.includes("PLU_BTNDESC")) {
            setProTouchDescDisable(true)
          }
          if (newlist.includes("PLU_STOCKCODE")) {
            setProStockDisable(true)
          }
          if (newlist.includes("PLU_VENDORPLU")) {
            setProVendorDisable(true)
          }
          if (newlist.includes("PLU_UNIT")) {
            setProUnitDisable(true)
          }
          if (newlist.includes("PLU_PURMODE")) {
            setProPurModeDisable(true)
          }
          if (newlist.includes("PLU_CS")) {
            setProCSDisable(true)
          }
          if (newlist.includes("PLU_COST")) {
            setProCostDisable(true)
          }
          if (newlist.includes("PLU_MARKUP")) {
            setProMarkupDisable(true)
          }
          if (newlist.includes("PLU_SELL")) {
            setProSellDisable(true)
          }
          if (newlist.includes("PLU_PACKPRICE")) {
            setProPackDisable(true)
          }
          if (newlist.includes("PLU_AVGCOST")) {
            setProAVGDisable(true)
          }
          if (newlist.includes("PLU_FIXGP")) {
            setProFixGPDisable(true)
          }
          if (newlist.includes("PLU_GP")) {
            setProGPDisable(true)
          }
          if (newlist.includes("PLU_MAXDISCPER")) {
            setProMaxDiscDisable(true)
          }
          if (newlist.includes("PLU_MAXDISCAMT")) {
            setProMaxDiscAmtDisable(true)
          }
          if (newlist.includes("PLU_ALLOWQTY")) {
            setProMaxAllowQtyDisable(true)
          }
          if (newlist.includes("PLU_PICTURE")) {
            setProPictureDisable(true)
          }
          if (newlist.includes("PLU_LANG1")) {
            setProLan1Disable(true)
          }
          if (newlist.includes("PLU_LANG2")) {
            setProLan2Disable(true)
          }
          if (newlist.includes("PLU_DESC")) {
            setProDescEnable(true)
          }
          if (newlist.includes("PLU_POSDESC")) {
            setProPosDescDisable(true)
          }
          if (newlist.includes("PLU_BTNDESC")) {
            setProTouchDescDisable(true)
          }
          if (newlist.includes("PLU_STOCKCODE")) {
            setProStockDisable(true)
          }
          if (newlist.includes("PLU_VENDORPLU")) {
            setProVendorDisable(true)
          }
          if (newlist.includes("PLU_UNIT")) {
            setProUnitDisable(true)
          }
          if (newlist.includes("PLU_PURMODE")) {
            setProPurModeDisable(true)
          }
          if (newlist.includes("PLU_CS")) {
            setProCSDisable(true)
          }
          if (newlist.includes("PLU_COST")) {
            setProCostDisable(true)
          }
          if (newlist.includes("PLU_MARKUP")) {
            setProMarkupDisable(true)
          }
          if (newlist.includes("PLU_SELL")) {
            setProSellDisable(true)
          }
          if (newlist.includes("PLU_PACKPRICE")) {
            setProPackDisable(true)
          }
          if (newlist.includes("PLU_AVGCOST")) {
            setProAVGDisable(true)
          }
          if (newlist.includes("PLU_FIXGP")) {
            setProFixGPDisable(true)
          }
          if (newlist.includes("PLU_GP")) {
            setProGPDisable(true)
          }
          if (newlist.includes("PLU_MAXDISCPER")) {
            setProMaxDiscDisable(true)
          }
          if (newlist.includes("PLU_MAXDISCAMT")) {
            setProMaxDiscAmtDisable(true)
          }
          if (newlist.includes("PLU_ALLOWQTY")) {
            setProMaxAllowQtyDisable(true)
          }
          if (newlist.includes("PLU_PICTURE")) {
            setProPictureDisable(true)
          }
          if (newlist.includes("PLU_LANG1")) {
            setProLan1Disable(true)
          }
          if (newlist.includes("PLU_LANG2")) {
            setProLan2Disable(true)
          }

          if (newlist.includes("PLU_ACTIVE")) {
            setProActiveDisable(true)
          }
          if (newlist.includes("PLU_POSACTIVE")) {
            setProPosActiveDisable(true)
          }
          if (newlist.includes("PLU_ORDERACTIVE")) {
            setProOrderActiveDisable(true)
          }
          if (newlist.includes("PLU_OPEN")) {
            setProOpenDisable(true)
          }
          if (newlist.includes("PLU_BUNDLE")) {
            setProBundleDisable(true)
          }
          if (newlist.includes("PLU_DECIMAL")) {
            setProDecimalDisable(true)
          }
          if (newlist.includes("PLU_EXP")) {
            setProExpDisable(true)
          }
          if (newlist.includes("PLU_DIRGRN")) {
            setProDIRGRNDisable(true)
          }
          if (newlist.includes("PLU_HOPRICE")) {
            setProHOPriceDisable(true)
          }
          if (newlist.includes("PLU_FASTMOVE")) {
            setProFastMoveDisable(true)
          }
          if (newlist.includes("PLU_RAWITEM")) {
            setProRawItemDisable(true)
          }
          if (newlist.includes("PLU_NODISC")) {
            setProNoDiscDisable(true)
          }
          if (newlist.includes("PLU_MP")) {
            setProMPDisable(true)
          }
          if (newlist.includes("PLU_MINUSALLOW")) {
            setProMinusDisable(true)
          }
          if (newlist.includes("PLU_ALLOWQTY")) {
            setProAllowQTYDisable(true)
          }
          if (newlist.includes("PLU_EXCHANGABLE")) {
            setProAloowExchange(true)
          }
          if (newlist.includes("PLU_REF1")) {
            setProRef1Disable(true)
          }
          if (newlist.includes("PLU_REF2")) {
            setProRef2Disable(true)
          }
          if (newlist.includes("PLU_REF3")) {
            setProRef3Disable(true)
          }
          if (newlist.includes("PLU_REF4")) {
            setProRef4Disable(true)
          }
          if (newlist.includes("PLU_REF5")) {
            setProRef5Disable(true)
          }
          if (newlist.includes("PLU_RETURN")) {
            setProReturnDisable(true)
          }
          if (newlist.includes("PLU_EMPTY")) {
            setEmptyBottleDisable(true)
          }
          if (newlist.includes("PLU_PRODUCTION_POS")) {
            setProductionPOSDisable(true)
          }
          if (newlist.includes("PLU_MINSELL")) {
            setProMinSellDisable(true)
          }
          if (newlist.includes("PLU_SHORT_EXPIRY_DAYS")) {
            setShortExpieryDisable(true)
          }
          if (newlist.includes("PLU_ALLOW_COST_ZERO")) {
            setAllowCostZeroDisable(true)
          }
          if (newlist.includes("PLU_IS_COMBINE_ITEM")) {
            setIsCombineItemDisable(true)
          }
          setTimeout(() => {
            ActiveStatusFunc(ActiveStatus);
          }, 1000);

          setBtnAutoActivation(ActiveStatus)

          for (let i = 1; i < 40; i++) {
            if (newlist.includes("PLU_GROUP" + i)) {
              groups.push(i)
            }
          }

          setGroupsDisable(groups)

          SetLoadingAlert(false)

        }).catch(error => {
          console.log('error', error)
          SetLoadingAlert(false)
        }
        );
    }

    getVariantnames()
    getNonEditable()
    getAllColors()
    getAllSizes()
    getVariantBatch()
    InventoryAndGroupReset()
  }, [])




  async function getAutoCodeFromAPI(menu) {

    var autoCodeRes = await fetchProductAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }



  function ActiveStatusFunc(ActiveStatus = []) {
    try {

      setTimeout(() => {
        const currentActiveStatus = ActiveStatus.length == 0 ? [...btnAutoActivation] : [...ActiveStatus]

        const statusMappings = {
          PLU_ACTIVE: SetActive,
          PLU_POSACTIVE: SetPosActive,
          PLU_ORDERACTIVE: SetBackOfficeActive,
          PLU_OPEN: SetOpen,
          PLU_BUNDLE: SetComposite,
          PLU_DECIMAL: SetWeighted,
          PLU_EXP: SetExpiry,
          PLU_MINUSALLOW: SetminusAllow,
          PLU_BATCHENABLE: SetbatchEnable,
          PLU_DIRGRN: SetDirectGRN,
          PLU_HOPRICE: SetSellingHo,
          PLU_FASTMOVE: Setfastmoving,
          PLU_RAWITEM: SetRaw,
          PLU_NODISC: SetPromotions,
          PLU_MP: SetMultiplePrices,
          PLU_VARIANTANABLE: SetvarientEnable,
          PLU_EXCHANGABLE: SetAllowExchange,
          PLU_ALLOW_COST_ZERO: setAllowCostZero,
          PLU_IS_COMBINE_ITEM: setIsCombineItem
        };

        Object.entries(statusMappings).forEach(([status, setter]) => {
          const isActive = currentActiveStatus.includes(status);
          setter(isActive);

          // Special case for PLU_VARIANTANABLE
          if (status === 'PLU_VARIANTANABLE' && isActive) {
            SetvarientEnable(false);
            setTimeout(() => {
              SetvarientEnable(true);
            }, 200);
          }

          if (status === 'PLU_ACTIVE' && isActive) {
            SetActive(false)
            setTimeout(() => {
              SetActive(true);
            }, 200);
          }

        });
        SetLoadingAlert(false);
      }, 500);

    } catch (error) {
      console.log("error", error)
      SetLoadingAlert(false);
    }

  }

  async function getAllColors() {

    await fetch(`${ApiURL}variant1`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    })
      .then(Response => Response.json())
      .then(responseData => {

        var dataset = []
        responseData.data.map((item, index) => {
          var rowitem = item
          rowitem.id = index + 1
          rowitem.apply = false
          dataset.push(rowitem)
        })
        setAllColors(dataset)

      }).catch(error => console.log("error", error))
  }

  async function getAllSizes() {
    await fetch(`${ApiURL}variant2`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    })
      .then(Response => Response.json())
      .then(responseData => {

        var dataset = []
        responseData.data.map((item, index) => {
          var rowitem = item
          rowitem.id = index + 1
          rowitem.apply = false
          dataset.push(rowitem)
        })

        setAllSizes(dataset)
      }).catch(error => console.log("error", error))
  }


  ///** Functions for Open default  Tab */
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    } else {
      setcustomActiveTab("1")
    }
  }

  ///** Functions for Tax Details add and delete */
  function handleAddRowNested() {
    const modifiedRows = [...arRow]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setarRow(modifiedRows)
  }

  function handleRemoveRow(id) {
    if (id !== 0) {
      var modifiedRows = [...arRow]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setarRow(modifiedRows)
    }
  }

  ///** Functions for Supplier Details add and delete */
  function handleAddRowNestedSupp() {
    const modifiedRows = [...arRowSup]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setarRowSupp(modifiedRows)
  }

  function handleRemoveRowSupp(id) {

    if (id !== 0) {
      var modifiedRows = [...arRowSup]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setarRowSupp(modifiedRows)

    }
  }
  ///** Functions for Price Details add and delete */
  function handleAddRowNestedPrice() {
    const modifiedRows = [...arRowPrice]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setarRowPrice(modifiedRows)
  }

  function handleRemoveRowprice(id) {
    if (id !== 0) {
      var modifiedRows = [...arRowPrice]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setarRowPrice(modifiedRows)
    }
  }
  ///** Functions for Barcode Details add and delete */
  function handleAddRowNestedBarcode() {
    const modifiedRows = [...arRowBarcode]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setarRowBarcode(modifiedRows)
  }

  function handleRemoveRowBarcode(id) {
    if (id !== 0) {
      var modifiedRows = [...arRowBarcode]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setarRowBarcode(modifiedRows)
    }
  }

  ///** Functions for Main search popup open and row select */
  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    ValueSetter(row.PLU_CODE)
    setmodal_xlarge(!modal_xlarge)
  }

  ///** Functions for Main search popup open and row select in Return/Emty Bottle*/
  const Return_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    ReturnValueSetter(row.PLU_CODE)
    setreturn_modal_xlarge(!return_modal_xlarge)
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  // Return/Emty Bottle
  function return_tog_xlarge() {
    setreturn_modal_xlarge(!return_modal_xlarge)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  // set new state(Form Clear Function)
  const handleNewClick = (keepOldData = false) => {
    try {

      SetLoadingAlert(true);
      SetLoadingAlerttitle("UI Refreshing...");

      if (keepOldData) {

        const currentGroups = optionGroup
        const group_length = currentGroups.length

        setTimeout(() => {
          //keep current group values
          const newGroupSet = optionGroup.map((row, index) => {
            if (index <= group_length) { // Simplified the condition
              return {
                ...row,
                groupCode: currentGroups[index]?.groupCode ?? "", // Optional chaining for safety
                groupName: currentGroups[index]?.groupName ?? "", // Optional chaining for safety
              };
            } else {
              return {
                ...row,
              };
            }
          });

          // Clear the rest of the groups
          const mptyGroups = newGroupSet.map((row, index) => {
            if (index > group_length) {
              return {
                ...row,
                groupCode: "",
                groupName: "",
              }
            } else {
              return {
                ...row,
              }
            }

          })

          setoptionGroup1(mptyGroups)
        }, 2000);


      } else {

        resetProSupplierWithDefaultLocation(proSup_default_loc)

        SetUnit("")
        SetPurchase("")
        SetCost("0.0")
        SetSelling("0.0")
        SetCasesize("1")
        setoptionGroup1([])
        SetProductDesc("")
        SetProductPOSDesc("")
        SetProductTouchDesc("")
        SetReference5("")
      }


      getAllColors()
      getAllSizes()
      InventoryAndGroupReset()
      setcustomActiveTab("1")
      setHandleClearStatus(prev => !prev)
      SetProductCode("")
      SetProductCodeEnable(false)
      setAlertShow(false)

      SetProductDescEnable(false)

      SetProductPOSDescEnable(false)

      SetProductTouchDescEnable(false)
      SetStockCode("")
      SetStockCodeEnable(false)
      SetVendorPLU("")
      SetVendorPLUEnable(false)

      SetUnitnable(false)

      SetPurchasenable(false)
      SetLanguage1("")
      SetLanguage1enable(false)
      SetLanguage2("")
      SetLanguage2enable(false)

      SetCasesizeenable(false)

      SetCostenable(false)
      setPreviousSelling(0)
      setPreviousCost(0)
      SetMarkup(parseFloat(default_markup).toFixed(2))
      SetMarkupenable(false)

      SetSellingenable(false)
      SetPackPrice("0.0")
      SetPackPriceenable(false)
      SetAVGCost("0.0")
      SetAVGCostenable(true)
      SetFixedGP("0.0")
      SetFixedGPenable(false)
      SetCurrGP("0.0")
      SetCurrGPenable(true)
      SetMaxDicPer("0.0")
      SetMaxDicPerenable(false)
      SetMaxDicAmt("0.0")
      SetMaxDicAmtenable(false)
      SetMaxAllowQty("0.0")
      setEmptyBottle(false)
      setProductionPOS(false)
      setAllowCostZero(false)
      setIsCombineItem(false)
      SetMaxAllowQtyenable(false)
      SetMinSell("0.0")
      SetActiveEnable(false)
      SetPosActiveEnable(false)
      SetPurOrderEnable(false)
      SetOpenEnable(false)
      SetCompositeEnable(false)
      SetWeightedEnable(false)
      SetExpiryEnable(false)
      setEmptyBottleEnable(false)
      SetDirectGRNEnable(false)
      SetSellingHoEnable(false)
      SetfastmovingEnable(false)
      SetRawEnable(false)
      SetPromotionsEnable(false)
      SetMultiplePricesEnable(false)
      SetReference1("")
      SetReference1Enable(false)
      SetReference2("")
      SetReference2Enable(false)
      SetReference3("")
      SetReference3Enable(false)
      SetReference4("")
      SetReference4Enable(false)

      SetReference5Enable(false)
      setErrorMsg("")
      setoInventory([])

      SetDeleteEnable(false)
      setReason("Created")
      setPermissionName("")
      setPermissionPassword("")
      setPermissionNameDisable(false)
      setSearchdisabled(false)
      setCodeButton(true)
      setFile(null)
      setInventoryShow(false)
      setFreeQtyList([
        { supplier: "", supplierName: "", supplierDisable: false, qtyFrom: 0, qtyTo: 0, freeQty: 0 }
      ])
      setProFormData(prev => ({
        ...prev,
        shortExpiryDays: 0
      }))
      //Set Audit log details for the recalled records****
      setCrBy("")
      setMdBy("")
      setCrDate("")
      setMdDate("")

      setSaveEnable(true)
      setCrEnable(false)
      detTableController(false)
      setAddNew(true)
      setDisabled(false)
      setPicture(photovalues)
      setImgName("")
      setInnerCaseSizes([])

      const currentDefaultLocations = [...defaultLocations]

      currentDefaultLocations.forEach((location) => {
        if (location.default) {
          location.checked = true
        } else {
          location.checked = false
          location.inInventory = false
        }
      });

      setDefaultLocations(currentDefaultLocations)

      setExcelFailedResult([])
      setExcelSuccessResult([])
      setMultiplePriceList([])
      setAllColors([])
      setAllSizes([])
      setMergerItems([{
        id: 1,
        proCode: "",
        code: "",
        name: "",
        variant1: "",
        variant2: "",
        cost: parseFloat(0).toFixed(2),
        avgCost: parseFloat(0).toFixed(2),
        reOrderlvl: "",
        reOrderQty: "",
        maxlvl: "",
        opBal: "",
        sih: 0,
        color: "",
        selling: parseFloat(0).toFixed(2),
        linkCost: parseFloat(0).toFixed(2),
      }])

      setVariantPNG('')
      setPNGPath(ReportURL + "Variants/Other.png")
      setLocationPriceForm({
        searchPram: "",
        searchBy: "Loccode",
        placeHolder: "Search by Location",
      })
      setPriceChanges(0)
      setReturnCode('')
      setReturnDescription('')
      setarRow([{ id: 1, code: '', taxCodeDisable: false, desc: '', state: true }])

      setarRowPrice([{
        id: 1,
        Loccode: "",
        code: "",
        desc: "",
        StartDate: today,
        EndDate: today,
        StartQty: 0,
        EndQty: 0,
        DiscountPer: 0,
        DiscountAmt: 0,
        FixedPrice: 0,
        state: true,
        priceCodeDisable: true,
        supContribute: 0,
        comContribute: 0
      }])
      setarRowBarcode([{ id: 1, code: '', desc: '', RefNo: '', state: true }])


      setTimeout(() => {
        ActiveStatusFunc()
      }, 1000);

      getAutoCodeFromAPI(menuCode)

    } catch (error) {
      console.log('error', error)
      SetLoadingAlert(false);
    }

  }

  // Enable edit
  const handleEditClick = () => {


    setDisabled(false)
    SetProductCodeEnable(true)
    SetProductDescEnable(false)
    SetProductPOSDescEnable(false)
    SetProductTouchDescEnable(false)
    SetStockCodeEnable(true)
    SetVendorPLUEnable(false)
    SetUnitnable(false)
    SetPurchasenable(false)
    SetLanguage1enable(false)
    SetLanguage2enable(false)
    SetCasesizeenable(false)
    SetCostenable(false)
    SetMarkupenable(false)
    SetSellingenable(false)
    SetPackPriceenable(false)
    SetAVGCostenable(true)
    SetFixedGPenable(false)
    SetCurrGPenable(true)
    SetMaxDicPerenable(false)
    SetMaxDicAmtenable(false)
    SetMaxAllowQtyenable(false)
    SetActiveEnable(false)
    SetPosActiveEnable(false)
    SetPurOrderEnable(false)
    SetOpenEnable(false)
    SetCompositeEnable(false)
    SetWeightedEnable(false)
    SetExpiryEnable(false)
    setEmptyBottleEnable(false)
    SetDirectGRNEnable(false)
    SetSellingHoEnable(false)
    SetfastmovingEnable(false)
    SetRawEnable(false)
    SetPromotionsEnable(false)
    SetMultiplePricesEnable(false)
    SetReference1Enable(false)
    SetReference2Enable(false)
    SetReference3Enable(false)
    SetReference4Enable(false)
    SetReference5Enable(false)
    SetUnitnable(false)
    SetPurchasenable(false)
    SetLanguage1enable(false)
    SetLanguage2enable(false)
    setSaveEnable(true)
    detTableController(false)
    SetDeleteEnable(true)
  }

  //Save Data
  const SaveData = async (priceCHanges = false) => {


    if (file && AddNew == true) {

      try {
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Uploading Products...")
        const { success, msg, successTable, unsuccessTable } = await handleUploadProducts(file, LogUserType, LocationCode)
        SetLoadingAlert(false)
        if (success) {
          displayAlertMessage('success', msg)
          setFile(null)
          setExcelSuccessResult(successTable)
          setExcelFailedResult(unsuccessTable)
          setToggleExcelUploadPopup(true)
        } else {
          displayAlertMessage('danger', msg)
          setFile(null)
          setExcelFailedResult([])
          setExcelSuccessResult([])
          setToggleExcelUploadPopup(false)
        }

      } catch (error) {
        SetLoadingAlert(false)
        setFile(null)
        setExcelFailedResult([])
        setExcelSuccessResult([])
        console.log('error', error)
      }

    } else {

      //set autogenerate code to as CODE just for display purpuse
      if (AddNew == true && nullCode == false) {
        SetProductCode(autoCode)
      }

      //Validation 
      if (strProductCode.length == 0 && nullCode == true) {
        displayAlertMessage('danger', "Product Code is Empty !")
        return
      }
      if (strProductDesc.length == 0) {
        displayAlertMessage('danger', "Product Descripton is Empty !")
        return
      }

      if (strUnit == "") {
        displayAlertMessage('danger', "Please select Unit !")
        return
      }

      if (!isCombineItem) {

        if (dbCost == 0.0 && setIntFromBool(blOpen) == 0 && setIntFromBool(blRaw) == 0 && !allowCostZero) {
          displayAlertMessage('danger', "Cost Price is Empty !")
          return
        }

        if (dbSelling == 0.0 && setIntFromBool(blOpen) == 0 && setIntFromBool(blRaw) == 0) {
          displayAlertMessage('danger', "Selling Price is Empty !")
          return
        }

      }


      //get Tax table data
      var TaxDet = []

      arRow.forEach((item, index) => {
        if (item.code && item.code != "") {
          TaxDet.push(TaxDetBuilder(strProductCode, item.code, item.state))
        }
      })

      //get BARCODE table data
      var BarcodeDet = []
      arRowBarcode.forEach((item, index) => {
        if (item.code && item.code != "" && item.RefNo != "") {
          BarcodeDet.push(BarCodeBuilder(strProductCode, item.code, item.RefNo, item.state))
        }

      })

      //get SUPPLIER table data
      var SupplierDet = []
      arRowSup.forEach((item, index) => {
        if (item.code && item.code != "") {
          SupplierDet.push(SupplierBuilder(strProductCode, item.Loccode, item.code, item.selling, item.Discount, item.Cost, item.Markup, item.AfterMarkup, item.state))
        }
      })

      if (SupplierDet.length == 0) {
        displayAlertMessage('danger', "Please select at least one default supplier !")
        return
      }

      if (!SupplierDet.some((item) => item.DEFAULTSUPPLIER == true)) {
        displayAlertMessage('danger', "Please select at least one default supplier !")
        return
      }

      var code = AddNew == true && nullCode == false ? autoCode : strProductCode

      //get pRICE table data
      var PriceDet = []
      let priceDetErrorCount = 0;

      const rowsWithData = arRowPrice.filter((item) => item.Loccode != "" || item.code != "")

      arRowPrice.forEach((item, index) => {
        if (item.Loccode != "" && item.code != "") {
          PriceDet.push(PriceBuilder(
            code,
            item.Loccode,
            item.code,
            item.StartDate,
            item.EndDate,
            item.StartQty,
            item.EndQty,
            item.DiscountPer,
            item.DiscountAmt,
            item.FixedPrice,
            item.state,
            item.supContribute,
            item.comContribute
          ))
        } else {
          priceDetErrorCount += 1;
        }
      })


      if (priceDetErrorCount > 0 && rowsWithData.length > 0) {
        displayAlertMessage('danger', "Please select location and price mode !")
        setcustomActiveTab("9")
        return
      }


      //combination table data
      let CombinationDet = []

      mergerItems.forEach((item, index) => {
        if (item.proCode != "" && item.code != "") {
          CombinationDet.push({
            PLUCODE: item.proCode,
            VC_VARIANT1CODE: item.variant1,
            VC_VARIANT2CODE: item.variant2,
            COMBINATIONCODE: item.code,
            COMBINATIONNAME: item.name,
            COST: parseFloat(item.cost),
            AVGCOST: parseFloat(item.avgCost),
            SELLING: parseFloat(item.selling),
            SPECIALPRICE: parseFloat(item.linkCost),
            RELEVEL: parseFloat(item.reOrderlvl),
            REQTY: parseFloat(item.reOrderQty),
            MAXLEVEL: parseFloat(item.maxlvl),
            OPQTY: parseFloat(item.opBal),
            SIH: parseFloat(item.sih)
          })
        }
      })


      if (varientEnable == false) {
        CombinationDet = []
      } else {
        if (CombinationDet.length == 0) {
          displayAlertMessage('danger', "Please add at least one variant !")
          return
        }
      }

      if (optionGroup.every((item) => item.groupCode == "")) {
        displayAlertMessage('danger', "Need to assign at least one group !")
        return
      }

      // Check only up to the length of the optionGroup array if it's shorter than numberOfEntries
      if (validate_groups > 1) {
        const entriesToCheck = Math.min(optionGroup.length, validate_groups);

        // Check if the first 'entriesToCheck' items have an empty or 'N/A' groupCode
        if (optionGroup.slice(0, entriesToCheck).some((item) => item.groupCode == "" || String(item.groupCode).trim().toLowerCase() == "n/a")) {
          displayAlertMessage('danger', `Need to assign a valid code for the first ${entriesToCheck} Attributes!`);
          return;
        }
      }


      var GroupDet = []

      GroupDet.push({
        PLUCODE: code,
        GROUPCODE1: optionGroup[0]?.groupCode ?? "",
        GROUPCODE2: optionGroup[1]?.groupCode ?? "",
        GROUPCODE3: optionGroup[2]?.groupCode ?? "",
        GROUPCODE4: optionGroup[3]?.groupCode ?? "",
        GROUPCODE5: optionGroup[4]?.groupCode ?? "",
        GROUPCODE6: optionGroup[5]?.groupCode ?? "",
        GROUPCODE7: optionGroup[6]?.groupCode ?? "",
        GROUPCODE8: optionGroup[7]?.groupCode ?? "",
        GROUPCODE9: optionGroup[8]?.groupCode ?? "",
        GROUPCODE10: optionGroup[9]?.groupCode ?? "",
        GROUPCODE11: optionGroup[10]?.groupCode ?? "",
        GROUPCODE12: optionGroup[11]?.groupCode ?? "",
        GROUPCODE13: optionGroup[12]?.groupCode ?? "",
        GROUPCODE14: optionGroup[13]?.groupCode ?? "",
        GROUPCODE15: optionGroup[14]?.groupCode ?? "",
        GROUPCODE16: optionGroup[15]?.groupCode ?? "",
        GROUPCODE17: optionGroup[16]?.groupCode ?? "",
        GROUPCODE18: optionGroup[17]?.groupCode ?? "",
        GROUPCODE19: optionGroup[18]?.groupCode ?? "",
        GROUPCODE20: optionGroup[19]?.groupCode ?? "",
        GROUPCODE21: optionGroup[20]?.groupCode ?? "",
        GROUPCODE22: optionGroup[21]?.groupCode ?? "",
        GROUPCODE23: optionGroup[22]?.groupCode ?? "",
        GROUPCODE24: optionGroup[23]?.groupCode ?? "",
        GROUPCODE25: optionGroup[24]?.groupCode ?? "",
        GROUPCODE26: optionGroup[25]?.groupCode ?? "",
        GROUPCODE27: optionGroup[26]?.groupCode ?? "",
        GROUPCODE28: optionGroup[27]?.groupCode ?? "",
        GROUPCODE29: optionGroup[28]?.groupCode ?? "",
        GROUPCODE30: optionGroup[29]?.groupCode ?? "",
        GROUPCODE31: optionGroup[30]?.groupCode ?? "",
        GROUPCODE32: optionGroup[31]?.groupCode ?? "",
        GROUPCODE33: optionGroup[32]?.groupCode ?? "",
        GROUPCODE34: optionGroup[33]?.groupCode ?? "",
        GROUPCODE35: optionGroup[34]?.groupCode ?? "",
        GROUPCODE36: optionGroup[35]?.groupCode ?? "",
        GROUPCODE37: optionGroup[36]?.groupCode ?? "",
        GROUPCODE38: optionGroup[37]?.groupCode ?? "",
        GROUPCODE39: optionGroup[38]?.groupCode ?? "",
        GROUPCODE40: optionGroup[39]?.groupCode ?? "",
      })

      //get Inventory table data
      var InventoryDet = []

      ProInventory.map((item, index) => {
        InventoryDet.push(
          InventoryBuilder(
            code,
            item.code,
            item.costPrice,
            item.avgCost,
            item.sellingPrice,
            item.reorderLevel,
            item.reorderQTY,
            item.maximumQTY,
            item.gondolaQTY,
            item.backShelf,
            item.frontShelf,
            item.openingStock,
            item.stockHand,
            item.state,
            item.stateBO,
            item.stockCode,
            item.bufferQTY
          )
        )

      })


      const selectedLocations = defaultLocations.filter((location) => location.checked).map((location) => {
        return {
          LOC_CODE: location.value
        }
      });


      const freeQtyFilteredList = freeQtyList.filter((item) => item.supplier != "" && item.qtyTo != 0 && item.freeQty != 0).map((item) => {
        return {
          supplier: item.supplier,
          qtyFrom: parseFloat(item.qtyFrom),
          qtyTo: parseFloat(item.qtyTo),
          freeQty: parseFloat(item.freeQty)
        }
      }
      )

      //Image upload
      var image = await ProductMasterImageUpload()
      //call save product method

      if (validateProductImage == 1 && image == "") {
        displayAlertMessage('danger', "Please select image !")
        return
      }


      SetLoadingAlert(true)
      if (AddNew == true) {
        SetLoadingAlerttitle("Saving...")
      } else {
        SetLoadingAlerttitle("Updating...")
      }

      let innerCaseSizesList = innerCaseSizes.map((item) => {
        return {
          size: parseInt(item.size),
        }
      }
      )
      const baseCSExists = innerCaseSizes.some((item) => item.size == strCasesize)

      if (!baseCSExists) {
        innerCaseSizesList.push({ size: parseInt(strCasesize) })
      }

      const strResult = await setProductSave(
        image,
        code,
        strProductDesc,
        strProductPOSDesc,
        strProductTouchDesc,
        strStockCode,
        strVendorPLU,
        strUnit,
        strPurchase,
        strLanguage1,
        strLanguage2,
        strCasesize,
        dbCost,
        dbMarkup,
        dbSelling,
        dbPackPrice,
        dbAVGCost,
        dbFixedGP,
        dbCurrGP,
        dbMaxDicPer,
        dbrMaxDicAmt,
        dbrMaxAllowQty,
        setIntFromBool(blActive),
        setIntFromBool(false),
        setIntFromBool(false),
        // setIntFromBool(blPosActive),
        // setIntFromBool(backofficeActive),
        setIntFromBool(blOpen),
        setIntFromBool(blComposite),
        setIntFromBool(blWeighted),
        setIntFromBool(blExpiry),
        setIntFromBool(blDirectGRN),
        setIntFromBool(blSellingHo),
        setIntFromBool(blfastmoving),
        setIntFromBool(blRaw),
        setIntFromBool(!blPromotions),
        setIntFromBool(blMultiplePrices),
        strReference1,
        strReference2,
        strReference3,
        strReference4,
        strReference5,
        TaxDet,
        BarcodeDet,
        SupplierDet,
        PriceDet,
        GroupDet,
        InventoryDet,
        setIntFromBool(AddNew),
        LogUserType,
        menuCode,
        LogCompanyCode,
        LocationCode,
        strReason,
        minusAllow,
        CombinationDet,
        batchEnable,
        varientEnable,
        varientEnable == true && variantPNG == '' ? PNGPath : variantPNG,
        allowExchange,
        priceCHanges,
        strReturnCode,
        emptyBottle,
        productionPOS,
        dbMinSell,
        multiplePriceList,
        setIntFromBool(allowCostZero),
        setIntFromBool(isCombineItem),
        selectedLocations,
        innerCaseSizesList,
        freeQtyFilteredList,
        proFormData.shortExpiryDays
      )

      const responseData = await strResult.json();
      SetLoadingAlert(false)

      if (responseData.success == false) {
        if (responseData.data == "Code Already Exsist!") {
          setCodeButton(false)
        }
        displayAlertMessage('danger', responseData.data)
      }
      else {
        if (AddNew && (excludefrom_productreset == 1)) {
          setAlertDescription("Do you want to keep the current Attributes , Supplier , Unit And Purchasing Mode ?")
          setAlertConfirmOption(14)
          setsweetAlertShow(true)
        } else {
          handleNewClick();
        }

        displayAlertMessage('success', responseData.data)
      }
    }
  }

  const ProductMasterImageUpload = async () => {

    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");
    let message = "";

    const strCodeToUse = AddNew == true && nullCode == false ? autoCode : strProductCode

    if (strCodeToUse === "") {
      return message;
    }

    try {
      if (picture.imageFile) {
        const formdata = new FormData();

        formdata.append("strCode", strCodeToUse);
        formdata.append("img", picture.imageFile);
        formdata.append("strSerial", localStorage.getItem("Serial") || "");

        const requestOptions = {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${authToken}`
          },
          body: formdata,
          redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}Product/image`, requestOptions);
        const responseData = await response.json();
        if (responseData.success) {
          message = responseData.data;
        }
      } else if (imgName) {
        message = imgName.slice(15);
      }

      // If neither picture.imageFile nor imgName is available, message remains an empty string.
    } catch (error) {
      console.error('Error:', error);
    }

    return message;
  };



  //************ Image Upload Function End*/

  //bool convert to int
  const setIntFromBool = blParameter => {
    if (blParameter) {
      return 1
    } else {
      return 0
    }
  }

  //tax table Array
  const TaxDetBuilder = (ProductCode, TaxCode, swActive) => {
    return {
      PLUCODE: ProductCode,
      TAXCODE: TaxCode,
      ACTIVE: setIntFromBool(swActive),
    }
  }

  //Barcode table Array
  const BarCodeBuilder = (ProductCode, LocCode, RefNo, swActive) => {
    return {
      PLUCODE: ProductCode,
      LOCATIONCODE: LocCode,
      REFCODE: RefNo,
      ACTIVE: setIntFromBool(swActive),
    }
  }

  //Inventory table Array
  const InventoryBuilder = (
    ProductCode,
    LocCode,
    CostPrice,
    AVGCost,
    SellingPrice,
    ReorderLevel,
    ReorderQTY,
    MaximumQTY,
    GondolaQTY,
    BackShelf,
    FrontShelf,
    OpeningStock,
    StockHand,
    swActive,
    stateBO,
    STOCKCODE,
    bufferQTY
  ) => {
    return {
      PLUCODE: ProductCode,
      LOCATIONCODE: LocCode,
      SHELF_B: BackShelf == undefined || BackShelf == null ? "" : BackShelf,
      SHELF_F: FrontShelf == undefined || FrontShelf == null ? "" : FrontShelf,
      ACTIVE: setIntFromBool(swActive),
      ACTIVEBO: setIntFromBool(stateBO),
      COST: CostPrice == null ? parseFloat(0) : parseFloat(CostPrice),
      AVGCOST: AVGCost == null ? parseFloat(0) : parseFloat(AVGCost),
      SELLING: SellingPrice == null ? parseFloat(0) : parseFloat(SellingPrice),
      RELEVEL: ReorderLevel == null ? parseFloat(0) : parseFloat(ReorderLevel),
      REQTY: ReorderQTY == null ? parseFloat(0) : parseFloat(ReorderQTY),
      MAXLEVEL: MaximumQTY == null ? parseFloat(0) : parseFloat(MaximumQTY),
      GONDOLA: GondolaQTY == null ? parseFloat(0) : parseFloat(GondolaQTY),
      SIH: StockHand == null ? parseFloat(0) : parseFloat(StockHand),
      OPQTY: OpeningStock == null ? parseFloat(0) : parseFloat(OpeningStock),
      STOCKCODE: STOCKCODE,
      BUFFERQTY: bufferQTY == null ? parseFloat(0) : parseFloat(bufferQTY),
    }
  }

  //Supplier table Array
  const SupplierBuilder = (
    ProductCode,
    LocCode,
    SupplierCode,
    Selling,
    Discount,
    Cost,
    Markup,
    AfterMarkup,
    swActive
  ) => {
    return {
      PLUCODE: ProductCode,
      LOCATIONCODE: LocCode,
      SUPPLIERCODE: SupplierCode,
      DEFAULTSUPPLIER: setIntFromBool(swActive),
      SUPPLIERSELLING: parseFloat(Selling),
      COST: parseFloat(Cost),
      DISCPER: parseFloat(Discount),
      MARKUP: parseFloat(Markup),
      SELLINGAFTERMARKUP: parseFloat(AfterMarkup),
    }
  }

  //Price table Array
  const PriceBuilder = (
    ProductCode,
    Loccode,
    PriceModeCode,
    StartDate,
    EndDate,
    StartQty,
    EndQty,
    DiscountPer,
    DiscountAmt,
    FixedPrice,
    swActive,
    supContribute,
    comContribute
  ) => {
    return {
      PLUCODE: ProductCode,
      LOCATIONCODE: Loccode,
      PRICEMODE: PriceModeCode,
      ACTIVE: setIntFromBool(swActive),
      DATE_S: StartDate,
      DATE_E: EndDate,
      QTY_S: parseFloat(StartQty),
      QTY_E: parseFloat(EndQty),
      DISCOUNTPER: parseFloat(DiscountPer),
      DISCOUNTAMT: parseFloat(DiscountAmt),
      FIXPRICE: parseFloat(FixedPrice),
      SUPCONTRIBUTE: parseFloat(supContribute),
      COMCONTRIBUTE: parseFloat(comContribute),
    }
  }

  // Set values to variables(Data Recall main method)
  const ValueSetter = async code => {
    setInventoryShow(false)

    if (validateSpecialCharacters(code) == true) {
      SetProductCode("")
      return
    }
    if (code != "") {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")

      let Data = await getProductDetailsCode(code, LocationCode, LogUserType)

      SetLoadingAlert(false)

      if (Data.length > 0) {
        setarRow([])
        setarRowSupp([])

        setarRowBarcode([])
        let modifiedRows = []
        let modifiedRowsSupp = []
        let modifiedRowsPrice = []
        let modifiedRowsBar = []
        let modifiedCombinations = []
        setSaveEnable(false)
        setCrEnable(true)
        setAddNew(false)
        SetProductCode(Data[0].strProductCode)
        SetProductCodeEnable(true)
        SetProductDesc(Data[0].strProductDesc)
        SetProductDescEnable(true)
        SetProductPOSDesc(Data[0].strProductPOSDesc)
        SetProductPOSDescEnable(true)
        SetProductTouchDesc(Data[0].strProductBtnDesc)
        SetProductTouchDescEnable(true)
        SetStockCode(Data[0].strStockCode)
        SetStockCodeEnable(true)
        SetVendorPLU(Data[0].strVendorPLU)
        SetVendorPLUEnable(true)
        SetUnit(Data[0].strUnit)
        SetPurchase(Data[0].strPurchasingMode)
        SetLanguage1(Data[0].strLanguage1)
        SetLanguage2(Data[0].strLanguage2)
        SetUnitnable(true)
        SetPurchasenable(true)
        SetLanguage1enable(true)
        SetLanguage2enable(true)
        SetCasesize(Data[0].dbCaseSize)
        SetCasesizeenable(true)
        SetCost(Data[0].dbCost)
        setPreviousCost(Data[0].dbCost)
        SetCostenable(true)
        SetMarkup(Data[0].dbMarkup)
        SetMarkupenable(true)
        SetSelling(Data[0].dbSelling)
        setPreviousSelling(Data[0].dbSelling)
        setPriceChanges(parseFloat(Data[0].dbSelling))
        SetSellingenable(true)
        SetPackPrice(Data[0].dbPackPrice)
        SetPackPriceenable(true)
        SetAVGCost(Data[0].dbAvgCost)
        SetAVGCostenable(true)
        SetFixedGP(Data[0].dbFixGp)
        SetFixedGPenable(true)

        let valGP = CalculateCurrentGP(Data[0].dbSelling, Data[0].dbCost, Data[0].dbCaseSize)
        SetCurrGP(parseFloat(valGP, 10).toFixed(2))

        // SetCurrGP(Data[0].dbGP)
        SetCurrGPenable(true)
        SetMaxDicPer(Data[0].dbMaxDisPer)
        SetMaxDicPerenable(true)
        SetMaxDicAmt(Data[0].dbMaxDisAmt)
        SetMaxDicAmtenable(true)
        SetMaxAllowQty(Data[0].dbMaxAllowQty)
        SetMaxAllowQtyenable(true)
        SetActive(Data[0].isActive)
        SetPosActive(Data[0].isPosActive)
        SetPosActiveEnable(true)
        SetminusAllow(Data[0].isMinusAllow)
        SetActiveEnable(true)
        SetBackOfficeActive(Data[0].isOrderActive)
        SetPurOrderEnable(true)
        SetOpen(Data[0].isOpen)
        SetOpenEnable(true)
        SetComposite(Data[0].isBundle)
        SetCompositeEnable(true)
        SetWeighted(Data[0].isDecimal)
        SetWeightedEnable(true)
        SetExpiry(Data[0].isExp)
        SetExpiryEnable(true)
        SetDirectGRN(Data[0].isDirectGrn)
        SetDirectGRNEnable(true)
        SetSellingHo(Data[0].dbHoPrice)
        SetSellingHoEnable(true)
        Setfastmoving(Data[0].dbFastMove)
        SetfastmovingEnable(true)
        SetRaw(Data[0].dbRawItem)
        SetRawEnable(true)
        SetPromotions(!Data[0].dbNoDisc)
        SetPromotionsEnable(true)
        SetMultiplePrices(Data[0].dbMp)
        SetMultiplePricesEnable(true)
        SetReference1(Data[0].strRef1)
        SetReference1Enable(true)
        SetReference2(Data[0].strRef2)
        SetReference2Enable(true)
        SetReference3(Data[0].strRef3)
        SetReference3Enable(true)
        SetReference4(Data[0].strRef4)
        SetReference4Enable(true)
        SetReference5(Data[0].strRef5)
        SetReference5Enable(true)
        setCrBy(Data[0].createdBy)
        setMdBy(Data[0].modifiedDate)
        setCrDate(Data[0].createdDate)
        setMdDate(Data[0].modifiedBy)
        SetMaxAllowQty(Data[0].dbAllowedQty)
        setEmptyBottle(Data[0].emptyBottle == 1 ? true : false)
        setProductionPOS(Data[0].productionPOS == 1 ? true : false)
        setAllowCostZero(Data[0].allowCostZero == 1 ? true : false)
        setIsCombineItem(Data[0].isCombineItem == 1 ? true : false)
        setProFormData(prev => ({
          ...prev,
          shortExpiryDays: Data[0].shortExpiryDays == null ? 0 : Data[0].shortExpiryDays
        }))
        setEmptyBottleEnable(true)
        setSearchdisabled(true)
        SetbatchEnable(Data[0].batchEnable)
        SetvarientEnable(Data[0].variantEnable)
        setPNGPath(ReportURL + Data[0].strVariantPNG)
        setVariantPNG(Data[0].strVariantPNG)
        SetAllowExchange(Data[0].allowExchange)
        setMultiplePriceList(Data[0].multiplePrices)

        setHandleClearStatus(prev => !prev)
        // Return/Emty Bottle
        setReturnCode(Data[0].strReturnProductCode)
        setReturnDescription(Data[0].strReturnProductDesc)
        SetMinSell(Data[0].dbMinSell)
        setInnerCaseSizes(Data[0].innerCaseSizesList)
        setFreeQtyList(Data[0].freeQtyList.length > 0 ? Data[0].freeQtyList :
          [
            { supplier: "", supplierName: "", supplierDisable: false, qtyFrom: 0, qtyTo: 0, freeQty: 0 }
          ]
        )

        /* Changed by : Madhura Liyanage
          Changed On : 30/11/2022
          Reason : Changed all image storage/accessing location to media server
        */
        //---------Beginning of change ---------------------------------------------------------------------------------------------------------------
        //setPicture(Data[0].strImagePath == "images/product/" ? photovalues : {

        //}), setImgName(Data[0].strImagePath),
        setPicture(Data[0].strImagePath == "images/product/" ? photovalues :
          {
            imageSrc: `${window.Links.MediaServer + localStorage.getItem("Serial") + "/"}${Data[0].strImagePath}`
          }
        )
        setImgName(Data[0].strImagePath)

        //---------End of change ---------------------------------------------------------------------------------------------------------------

        Data[0].m_TBLTaxDetails.map(dr => {
          modifiedRows.push({
            id: modifiedRows.length + 1,
            taxCodeDisable: true,
            code: dr.taxcode,
            desc: dr.taxdesc,
            state: dr.active,
          })
        })
        setarRow(modifiedRows)

        Data[0].m_TBLSupplierDetails.map(dr => {
          modifiedRowsSupp.push({
            id: modifiedRowsSupp.length + 1,
            Loccode: dr.locationcode,
            code: dr.suppliercode,
            desc: dr.supplierdes,
            state: dr.defaultsupplier == 1 ? true : false,
            selling: dr.supplierselling,
            Discount: dr.discper,
            Cost: dr.cost,
            Markup: dr.markup,
            AfterMarkup: dr.sellingaftermarkup,
            locationDisable: true,
            supplierDisable: true
          })
        })
        setarRowSupp(modifiedRowsSupp)

        // only use assign locations can be display to the user
        Data[0].m_TBLPriceDetails.map(dr => {
          const isLocationExist = userWiseLocations.find((item) => item.code == dr.locationcode)

          if (isLocationExist) {
            modifiedRowsPrice.push({
              id: modifiedRowsPrice.length + 1,
              Loccode: dr.locationcode,
              LocName: dr.locationname,
              code: dr.pricemode,
              desc: dr.pricedesc,
              StartDate: dr.datE_S,
              EndDate: dr.datE_E,
              StartQty: dr.qtY_S,
              EndQty: dr.qtY_E,
              DiscountPer: dr.discountper,
              DiscountAmt: dr.discountamt,
              FixedPrice: dr.fixprice,
              state: dr.active,
              priceCodeDisable: true,
              locCodeDisable: true,
              supContribute: dr.supContribute,
              comContribute: dr.comContribute
            })
          }

        })
        setarRowPrice(modifiedRowsPrice)

        Data[0].m_TBLReferenceDetails.map(dr => {
          modifiedRowsBar.push({
            id: modifiedRowsBar.length + 1,
            code: dr.locationcode,
            desc: dr.locationdesc,
            RefNo: dr.refcode,
            state: dr.active,
            locCodeDisable: true
          })
        })

        Data[0].m_TBLVARIANTCOMBINATIONS.map((dr, index) => {
          var variantcolor = allColors.filter(
            (item) => item.code == dr.vC_VARIANT1CODE
          )

          modifiedCombinations.push({
            id: index + 1,
            proCode: dr.plucode,
            code: dr.combinationcode,
            name: dr.combinationname,
            variant1: dr.vC_VARIANT1CODE,
            variant2: dr.vC_VARIANT2CODE,
            cost: parseFloat(dr.cost).toFixed(2),
            avgCost: parseFloat(dr.avgcost).toFixed(2),
            reOrderlvl: dr.relevel,
            reOrderQty: dr.reqty,
            maxlvl: dr.maxlevel,
            opBal: dr.opqty,
            sih: 0,
            color: variantcolor[0].reference != null ? variantcolor[0].reference : "",
            selling: parseFloat(dr.selling).toFixed(2),
            linkCost: parseFloat(dr.specialprice).toFixed(2),
          })
        })

        setarRowBarcode(modifiedRowsBar)
        // setMergerItems([])
        TableRecall(code);
        detTableController(true);
        setDisabled(true)
        SetDeleteEnable(true)

        setarRowSupp(modifiedRowsSupp == undefined || modifiedRowsSupp.length == 0 ? [{
          id: 1,
          AfterMarkup: 0,
          Markup: 0,
          Cost: 0,
          Discount: 0,
          selling: 0,
          code: "",
          Loccode: "",
          state: false,
          desc: "",
          locationDisable: false,
          supplierDisable: true
        }] : modifiedRowsSupp)
        setarRow(modifiedRows == undefined || modifiedRows.length == 0 ? [{ id: 1, code: '', taxCodeDisable: false, desc: '', state: true }] : modifiedRows)
        setarRowPrice(modifiedRowsPrice == undefined || modifiedRowsPrice.length == 0 ? [{
          id: 1,
          Loccode: "",
          code: "",
          desc: "",
          StartDate: today,
          EndDate: today,
          StartQty: 0,
          EndQty: 0,
          DiscountPer: 0,
          DiscountAmt: 0,
          FixedPrice: 0,
          state: true,
          priceCodeDisable: true,
          supContribute: 0,
          comContribute: 0
        }] : modifiedRowsPrice)
        setarRowBarcode(modifiedRowsBar == undefined || modifiedRowsBar.length == 0 ? [{ id: 1, code: '', desc: '', RefNo: '', state: true }] : modifiedRowsBar)
        setMergerItems(modifiedCombinations == undefined || modifiedCombinations.length == 0 ? [{
          id: 1,
          proCode: "",
          code: "",
          name: "",
          variant1: "",
          variant2: "",
          cost: parseFloat(0).toFixed(2),
          avgCost: parseFloat(0).toFixed(2),
          reOrderlvl: "",
          reOrderQty: "",
          maxlvl: "",
          opBal: "",
          sih: 0,
          color: "",
          selling: parseFloat(0).toFixed(2),
          linkCost: parseFloat(0).toFixed(2),
        }] : modifiedCombinations)
        setReason("Updated")
      } else {
        if (nullCode == false) {
          displayAlertMessage('success', "Record Not Found !")
          SetProductCodeEnable(true)
          SetProductCode("")
        } else {
          displayAlertMessage('success', "Record Not Found !")
        }
      }
    }
  }
  //page load main function(load group and inventory table)


  // Set Return/Emty Bottle values to variables(Data Recall main method)
  const ReturnValueSetter = async code => {

    if (code != "") {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")
      setReturnDescription('')

      let Data = await getProductDetailsCode(code, LocationCode, LogUserType)

      SetLoadingAlert(false)

      if (Data.length > 0) {

        if (strProductCode == Data[0].strProductCode) {
          displayAlertMessage('danger', 'Already selected product !')
          setReturnCode('')
          setReturnDescription('')

        } else {
          setReturnCode(Data[0].strProductCode)
          setReturnDescription(Data[0].strProductDesc)
        }
      } else {
        if (nullCode == false) {
          displayAlertMessage('success', "Record Not Found !")
          setReturnCode("")
          setReturnDescription("")
        } else {
          displayAlertMessage('success', "Record Not Found !")
          setReturnCode("")
          setReturnDescription("")
        }
      }
    }
  }

  //page clear(Load group and inventory table)
  async function InventoryAndGroupReset() {

    const groupSummary = await getGroupSummary("0")
    setoptionGroup1(groupSummary)

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUser = obj[2]

    const LocationsData = await getLocationsUserWise(LogUser)

    setUserWiseLocations(LocationsData)

    var ProInventory = []

    LocationsData.map((item, index) => {
      var dataRow = item
      dataRow.id = index
      dataRow.mainCode = ""
      dataRow.description = ""
      dataRow.availablestock = 0
      dataRow.stockHand = 0
      dataRow.state = false
      dataRow.stateBO = false
      dataRow.expiryDate = ""
      dataRow.stockCode = ""
      dataRow.bufferQTY = 0
      ProInventory.push(dataRow)
    })

    setoInventory(ProInventory)
  }

  async function refreshSIH() {
    if (strProductCode) {
      TableRecall(strProductCode)
    }
  }




  //* Group and invetory Search Function */
  async function TableRecall(code) {

    try {

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")

      setoptionGroup1([])
      let datalan2 = [...optionGroup]
      let Datalan3 = await getGroupSummary(code)

      Datalan3.map(async (dr) => {
        datalan2 = datalan2.filter(d => d.code !== dr.code)
      })

      Datalan3.map(async (dr) => {
        datalan2.push(dr)
      })

      datalan2.sort((a, b) => a.code - b.code);

      setoptionGroup1(datalan2)
      let locationSET = [...ProInventory]

      let DataLoc = await getProInventory(code, LogUserType)

      const setDefaultLocation = defaultLocations.map((item) => {
        if (item.default) {
          item.checked = true
        } else {
          item.checked = false
        }
        return item
      })

      //group DataLoc by code
      const uniqueLocations = [...new Set(DataLoc.map(item => item.code))];

      setDefaultLocation.forEach((item) => {
        if (uniqueLocations.includes(item.value)) {
          item.checked = true
          item.inInventory = true
        }
      });

      setDefaultLocations(setDefaultLocation)

      DataLoc.map(async (dr) => {
        locationSET = locationSET.filter(d => d.code !== dr.code)
      })

      DataLoc.map(async (dr, index) => {
        locationSET.push(dr)
      })

      locationSET.sort((a, b) => a.code - b.code);

      var FinalInventory = []

      locationSET.map(async (dr, index) => {
        var datarow = dr
        datarow.id = index
        FinalInventory.push(datarow)
      })

      //assign new available srock to inventory 

      const newStock = await getAvailableStock(code, LogUserType)

      const newInventorywithAvailableStock = FinalInventory.map((item) => {
        const newStockItem = newStock.find((stock) => stock.location == item.code && stock.stockCode == item.stockCode)
        return {
          ...item,
          stockHand: newStockItem ? newStockItem.total : 0,
          availablestock: newStockItem ? newStockItem.available : 0,
          costPrice: parseFloat(item.costPrice).toFixed(2),
          avgCost: parseFloat(item.avgCost).toFixed(2),
          sellingPrice: parseFloat(item.sellingPrice).toFixed(2),
        }
      })

      setoInventory(newInventorywithAvailableStock)
    } catch (error) {
      console.log(error.message)
    } finally {
      SetLoadingAlert(false)
    }

  }

  //* To control detail table(All table enable ,disable control) */
  const detTableController = disabled => {
    if (disabled == null) {
      disabled = true
    }
  }

  //********Delete button function */
  const handleDelete = async () => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": strProductCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": strReason,
      "strCreateBy": crBy
    };

    try {
      SetLoadingAlert(true);
      SetLoadingAlerttitle("Deleting...");

      const response = await fetch(`${ApiURL}Common/Delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(rowDelete)
      });

      SetLoadingAlert(false);
      const responseData = await response.json();
      if (response.ok) {

        if (responseData.data === "Cannot Delete, Record Already Used!") {
          displayAlertMessage('warning', responseData.data);
        } else {
          handleNewClick();
          displayAlertMessage('success', responseData.data);
        }
      } else {

        displayAlertMessage('danger', responseData.msg);

      }
    } catch (error) {
      console.log(error.message);
    }

  }

  //*********Delete button function end */

  // print Function
  async function handlePrint(option) {
    const authToken = localStorage.getItem("authToken")
    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")


    await fetch(`${ReportURL}api/Product/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${menuCode}/${strProductCode}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
      }).then(Response => Response.json())
      .then(responseData => {

        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }

  //**Permission Check */
  const permission = (operation) => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {
            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true && AddNew == true) {
                SaveData(false)
              } else if (Modify == true) {
                if (parseFloat(blPriceChanges) != parseFloat(dbSelling)) {
                  setAlertDescription("Do you want to add this to price change ?")
                  setAlertConfirmOption(10)
                  setsweetAlertShow(true)
                } else {
                  SaveData(false)
                }
              } else {
                if (operation == "Save" && AddNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")

                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        setDisabled(false)
        clearPermissionInputs()

      } else {
        handleNewClick()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }

  //CODE AUTO GEN
  function RemoveImage() {
    setPicture(photovalues)
    setImgName("")
  }


  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }

  useEffect(() => {

    const modifiedInventory = ProInventory.map((item) => {
      item.state = blActive
      item.stateBO = blActive
      return item
    })

    setoInventory(modifiedInventory)

  }, [blActive])




  const validateSpecialCharacters = (str) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    return specialCharRegex.test(str);
  };


  function reAllocateProductDescriptionToVariants() {

    const commonName = getCommonName(mergerItems)


    const updatedCombination = mergerItems.map(item => {
      // Check if the 'name' property contains the search term
      if (item.name.includes(commonName)) {
        // Update the 'name' property with the new product description
        item.name = item.name.replace(commonName, strProductDesc);
      }
      return item;
    });


    setMergerItems(updatedCombination)

  }

  function changeInventoryPrices() {

    const modifiedInventory = ProInventory.map((item) => {
      item.costPrice = AlertConfirmOption == 12 ? parseFloat(dbCost) : item.costPrice
      item.sellingPrice = AlertConfirmOption == 13 ? parseFloat(dbSelling) : item.sellingPrice
      return item
    })

    setoInventory(modifiedInventory)

  }

  function CalculateCurrentGP(selling, cost, caseSize) {

    let calculatedGP = 0

    const filterbyVat = arRow.find((item) => item.code == "VAT" && item.state == true)

    if (vatRate > 0 && calGP_WithTAX && filterbyVat) {
      calculatedGP = (((parseFloat(selling) - ((parseFloat(cost) / parseFloat(caseSize)) * (1 + (vatRate / 100)))) / parseFloat(selling)) * 100)
    } else {
      calculatedGP = (((parseFloat(selling) - (parseFloat(cost) / parseFloat(caseSize))) / parseFloat(selling)) * 100)
    }

    return isNaN(calculatedGP) ? 0 : parseFloat(calculatedGP).toFixed(txnDecimalAmt)

  }


  function calculateMarkup(valCost, strCasesize, selling, dbMarkup) {
    // If dbMarkup is greater than 0, return the same value
    if (parseFloat(dbMarkup) > 0) {
      return dbMarkup;
    }

    // If valCost, strCasesize, and selling are greater than 0, calculate the markup
    if (parseFloat(valCost) > 0 && parseFloat(strCasesize) > 0 && parseFloat(selling) > 0) {
      let costPerUnit = parseFloat(valCost) / parseFloat(strCasesize);
      let markup = ((parseFloat(selling) - parseFloat(costPerUnit)) / parseFloat(costPerUnit)) * 100;
      return parseFloat(markup).toFixed(2);
    }

    // Return 0 if conditions are not met
    return 0;
  }


  function resetProSupplierWithDefaultLocation(default_location) {


    if (default_location != "") {
      setarRowSupp([{
        id: 1,
        AfterMarkup: 0,
        Markup: 0,
        Cost: 0,
        Discount: 0,
        selling: 0,
        code: "",
        Loccode: default_location,
        state: false,
        desc: "",
        locationDisable: true,
        supplierDisable: false
      }])
    } else {
      setarRowSupp([{
        id: 1,
        AfterMarkup: 0,
        Markup: 0,
        Cost: 0,
        Discount: 0,
        selling: 0,
        code: "",
        Loccode: "",
        state: false,
        desc: "",
        locationDisable: false,
        supplierDisable: true
      }])

    }

  }




  const ToggleExcelUploadPopup = () => {
    setToggleExcelUploadPopup(!toggleExcelUploadPopup)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={menuName} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPAlert
                    confirm_both={sweetAlertShow}
                    title={menuName}
                    description={AlertDescription}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    onConfirm={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 1) {

                        if (AddNew == true && menuCreate == true && permissionReasonShow == false) {
                          SaveData(false)
                        } else if (AddNew == true && menuCreate == true && permissionReasonShow == true) {
                          handlePermissionAlert(LogUserType, "Created", true, true)
                        } else if (AddNew == false && menuModify == true && permissionReasonShow == false) {

                          if (parseFloat(blPriceChanges) != parseFloat(dbSelling)) {
                            setAlertDescription("Do you want to add this to price change ?")
                            setAlertConfirmOption(10)
                            setsweetAlertShow(true)
                          } else {
                            SaveData(false)
                          }
                        } else if (AddNew == false && menuModify == true && permissionReasonShow == true) {
                          handlePermissionAlert(LogUserType, "Updated", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }

                      } else if (AlertConfirmOption == 2) {
                        handleEditClick()
                      } else if (AlertConfirmOption == 3) {
                        history.push('/dashboard')
                      } else if (AlertConfirmOption == 4) {
                        handleNewClick()
                      } else if (AlertConfirmOption == 6) {
                        if (menuPrint == true && permissionReasonShow == false) {
                          setprintoptionShow(true)
                        } else if (menuPrint == true && permissionReasonShow == true) {
                          handlePermissionAlert(LogUserType, "Printed", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 5) {

                        if (AddNew == false && menuDelete == true && permissionReasonShow == false) {
                          handleDelete()
                        } else if (AddNew == false && menuDelete == true && permissionReasonShow == true) {
                          handlePermissionAlert(LogUserType, "Deleted", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 10) {
                        SaveData(true)
                      } else if (AlertConfirmOption == 11) {
                        reAllocateProductDescriptionToVariants()
                      } else if (AlertConfirmOption == 12 || AlertConfirmOption == 13) {
                        changeInventoryPrices()
                      } else if (AlertConfirmOption == 14) {
                        handleNewClick(true)
                      }
                    }}
                    onCancel={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 10) {
                        SaveData(false)
                      } else if (AlertConfirmOption == 14) {
                        handleNewClick()
                      }
                    }}


                  />
                  <DPPermission
                    confirm_both={permissionAlertShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    AlName={permissionName}
                    AlNameOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionName(val2)
                    }}
                    AlPassward={permissionPassword}
                    AlPasswardOnchange={e => {
                      let val2 = Text(e.target, 50, true, true, "any", true)
                      setPermissionPassword(val2)
                    }}
                    AlReason={strReason}
                    AlReasonOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setReason(val2)
                    }}
                    onConfirm={() => {
                      setPermissionAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        permission("Save")
                      } else if (AlertConfirmOption == 5) {
                        permission("Delete")
                      } else if (AlertConfirmOption == 6) {
                        permission("Print")
                      }
                    }}
                    onCancel={() => {
                      setPermissionAlertShow(false)
                      clearPermissionInputs()
                    }}
                  />
                  <DPPrintOption
                    confirm_both={printoptionShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    cancelColor={"danger"}
                    onConfirmpdf={() => {
                      handlePrint("PDF")
                      setprintoptionShow(false)
                    }}
                    onConfirmxcel={() => {
                      handlePrint("XCEL")
                      setprintoptionShow(false)
                    }}
                    onCancel={() => {
                      setprintoptionShow(false)
                    }}
                  />
                  <DPLoadingAlert
                    confirm_both={loadingAlert}
                    title={loadingAlertTitle}
                  />
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {

                      const supposedSellingPrice = parseFloat(dbCost) / parseFloat(strCasesize)

                      setAlertDescription(parseFloat(dbSelling) < parseFloat(supposedSellingPrice) ? "Selling price is less than cost price, Do you wish to continue saving ?" : "Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    //editEnable={!saveEnable && isHeadOffice}
                    editEnable={!saveEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?");
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)

                    }}
                  />
                  <DPProductExcelUploadPopUp
                    isOpen={toggleExcelUploadPopup}
                    mainTitle={"Product Excel upload Results"}
                    excelFailedResult={excelFailedResult}
                    excelSuccessResult={excelSuccessResult}
                    toggle={ToggleExcelUploadPopup}
                  />
                  <p />
                  <DPNavBar buttons={NewTabList} activeStatus={customActiveTab} />
                  <TabContent activeTab={customActiveTab} className="p-3 text">
                    {AlertShow ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                      </Alert>
                    ) : null}

                    {file ? (
                      <Alert color={"secondary"} role="alert">
                        {"Excel File selected click save to upload "}
                      </Alert>
                    ) : null}

                    <TabPane tabId="1">
                      <ProductGenContent
                        menuName={menuName}
                        menuCode={menuCode}
                        ErrorMsg={ErrorMsg}
                        GetSelectRow={Hed_SelectRowSearch}
                        Gen_Code={strProductCode}
                        Gen_Code_onKeyPress={e => {
                          if (e.charCode == 13) {
                            ValueSetter(strProductCode)
                          }
                        }}
                        Gen_Code_onBlur={e => {
                          ValueSetter(e.target.value)
                        }}
                        Gen_Code_OnChange={e => {
                          let valCode = Text(
                            e.target,
                            25,
                            true,
                            true,
                            "upper",
                            false
                          )
                          SetProductCode(valCode)
                        }}
                        Gen_Code_Enabled={blProductCodeEnable}
                        Gen_DataSearch={async () => {
                          tog_xlarge()
                        }}
                        DataTables={DataTables}
                        Hed_CodeSearchOpen={modal_xlarge}
                        Hed_CodeSearchTrigger={tog_xlarge}
                        Gen_Desc={strProductDesc}
                        Gen_Desc_OnChange={e => {
                          let valDesc = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetProductDesc(valDesc)
                          SetProductTouchDesc(valDesc)
                          if (valDesc.length > 40) {
                            SetProductPOSDesc(valDesc.slice(0, 40))
                          } else {
                            SetProductPOSDesc(valDesc)
                          }
                        }}
                        Gen_Desc_OnBlur={e => {
                          if (e.target.value != "" && varientEnable && mergerItems.length > 0) {
                            setAlertDescription("Do you want to change variant description ?")
                            setAlertConfirmOption(11)
                            setsweetAlertShow(true)
                          }
                        }}
                        Gen_Desc_Enabled={blProductDescEnable}
                        Gen_POSDesc={strProductPOSDesc}
                        Gen_POSDesc_OnChange={e => {
                          let valPOSDesc = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetProductPOSDesc(valPOSDesc)
                        }}
                        Gen_POSDesc_Enabled={blProductPOSDescEnable}
                        Gen_TouchDesc={strProductTouchDesc}
                        Gen_TouchDesc_OnChange={e => {
                          let valTouchDesc = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetProductTouchDesc(valTouchDesc)
                        }}
                        Gen_TouchDesc_Enabled={blProductTouchDescEnable}
                        Gen_StockCode={strStockCode}
                        Gen_StockCode_OnChange={e => {
                          let valStockCode = Text(
                            e.target,
                            25,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetStockCode(valStockCode)
                        }}
                        Gen_StockCode_Enabled={blStockCodeEnable}
                        Gen_VendorPLU={strVendorPLU}
                        Gen_VendorPLU_OnChange={e => {
                          let valVendorPLU = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetVendorPLU(valVendorPLU)
                        }}
                        Gen_VendorPLU_Enabled={blVendorPLUEnable}
                        Gen_CaseSize={strCasesize}
                        Gen_CaseSize_OnChange={e => {
                          let valCasesize = Numeric(e.target, 8, 0, false)
                          if (valCasesize == "") {
                            SetCasesize(1)
                          } else {
                            SetCasesize(valCasesize)
                          }
                        }}
                        Gen_CaseSize_onBlur={e => {
                          const valCasesize = DecimalValidation(e.target.value, 1, false, txnDecimalQty)
                          if (valCasesize < 1) {
                            SetCasesize(1)
                          }
                          else {
                            SetCasesize(valCasesize)
                            var selling = 0;
                            if (valCasesize > 1) {
                              if (dbSelling <= 0) {
                                selling = DecimalValidation(((dbCost / valCasesize) + ((dbCost / valCasesize) * dbMarkup / 100)), 0, true, txnDecimalAmt)
                              }
                              if (selling > 0) {
                                let valGP = DecimalValidation((((selling - dbCost / valCasesize) / selling) * 100), 0, true, 2)
                                SetCurrGP(valGP)
                              }
                            }
                          }
                        }}
                        Gen_CaseSize_Enabled={blCasesizeEnable}
                        Gen_CostPrice={dbCost}
                        Gen_CostPrice_OnChange={e => {
                          let valCost = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valCost == "") {
                            SetCost("0.0")
                          }
                          else {
                            SetCost(valCost)
                          }
                        }}
                        Gen_CostPrice_onBlur={e => {
                          let valCost = DecimalValidation(e.target.value.replace(',', ''), 0, true, txnDecimalAmt)
                          let selling = ((valCost / strCasesize) + ((valCost / strCasesize) * dbMarkup / 100))
                          if (dbSelling > 0) {
                            if (previousSelling == 0) {
                              let valGP = CalculateCurrentGP(selling, valCost, strCasesize)
                              SetCurrGP(valGP, 10)
                            } else {
                              let valGP = CalculateCurrentGP(dbSelling, valCost, strCasesize)
                              SetCurrGP(valGP, 10)
                            }

                          }
                          else {
                            let valGP = CalculateCurrentGP(selling, valCost, strCasesize)
                            SetCurrGP(valGP, 10)

                          }

                          if (parseFloat(previousSelling) == 0 && parseFloat(dbMarkup) > 0) {
                            SetSelling(DecimalValidation(selling, 0, true, txnDecimalAmt))
                          }

                          SetCost(valCost)

                          if (AddNew == false && parseFloat(previousCost) != parseFloat(valCost)) {
                            setAlertDescription("Do you want to change cost price location wise ?")
                            setAlertConfirmOption(12)
                            setsweetAlertShow(true)
                          }

                          const markup = calculateMarkup(valCost, strCasesize, dbSelling, dbMarkup)
                          SetMarkup(markup)

                        }}
                        Gen_CostPrice_Enabled={blCostEnable}
                        Gen_MarkupCost={dbMarkup}
                        Gen_MarkupCost_OnChange={e => {
                          let valMark = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valMark == "") {
                            SetMarkup(0.0)
                          }
                          else {
                            SetMarkup(valMark)
                          }

                        }}
                        Gen_MarkupCost_onBlur={e => {
                          let valMark = DecimalValidation(e.target.value.replace(',', ''), 0, true, txnDecimalAmt)

                          if (valMark == "") {
                            SetMarkup(0.0)
                          } else if (parseFloat(valMark) <= 100 && parseFloat(valMark) > 0) {
                            let selling = (dbCost / strCasesize) + ((dbCost / strCasesize) * dbMarkup / 100)
                            if (parseFloat(previousSelling) == 0 && parseFloat(valMark) > 0) {
                              SetSelling(DecimalValidation(selling, 0, true, txnDecimalAmt))
                            }

                          } else {
                            if (parseFloat(previousSelling) == 0 && parseFloat(valMark) > 0) {
                              SetSelling(DecimalValidation(dbCost, 0, true, txnDecimalAmt))
                            }

                          }

                          if (valMark <= 100) {
                            let selling = (dbCost / strCasesize) + ((dbCost / strCasesize) * dbMarkup / 100)
                            if (dbSelling <= 0) {
                              SetMarkup(parseFloat(valMark, 10))
                              selling = (dbCost / strCasesize) + ((dbCost / strCasesize) * dbMarkup / 100)
                              if (parseFloat(previousSelling) == 0 && parseFloat(valMark) > 0) {
                                SetSelling(DecimalValidation(selling, 0, true, txnDecimalAmt))
                              }

                            }
                            else {
                              SetMarkup(parseFloat(valMark, 10))
                            }
                            if (selling > 0) {
                              if (previousSelling == 0) {

                                let valGP = CalculateCurrentGP(selling, dbCost, strCasesize)
                                SetCurrGP(parseFloat(valGP, 10).toFixed(2))

                              } else {

                                let valGP = CalculateCurrentGP(dbSelling, dbCost, strCasesize)
                                SetCurrGP(parseFloat(valGP, 10).toFixed(2))

                              }

                            }
                            else {
                              SetCurrGP(0.0)
                            }

                          } else {
                            SetMarkup(0.0)
                          }

                        }}
                        Gen_MarkupCost_Enabled={blMarkupEnable}
                        Gen_SellingPrice={dbSelling}
                        Gen_SellingPrice_OnChange={e => {
                          let valSelling = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valSelling == "") {
                            SetSelling("0.0")
                          }
                          else {
                            SetSelling(valSelling)
                          }
                        }}
                        Gen_SellingPrice_onBlur={e => {
                          let valSelling = DecimalValidation(e.target.value.replace(',', ''), 0, true, txnDecimalAmt)
                          SetSelling(DecimalValidation(valSelling, 0, true, txnDecimalAmt))

                          let newCost = dbCost;

                          if (parseFloat(dbCost) == 0) {
                            // Calculate the unit cost by reversing the selling price formula
                            const unitCost = valSelling / (1 + dbMarkup / 100);
                            // Calculate the total cost for the pack by multiplying by the pack size
                            const costPrice = unitCost * strCasesize;
                            newCost = costPrice;
                            SetCost(DecimalValidation(costPrice, 0, true, txnDecimalAmt))
                          }

                          if (valSelling > 0) {
                            // let valGP = (((valSelling - dbCost / strCasesize) / valSelling) * 100)
                            let valGP = CalculateCurrentGP(valSelling, newCost, strCasesize)
                            SetCurrGP(parseFloat(valGP, 10).toFixed(2))
                          }
                          else {
                            SetCurrGP(0.0)
                          }

                          const markup = calculateMarkup(dbCost, strCasesize, valSelling, dbMarkup)
                          SetMarkup(markup)


                          if (AddNew == false && parseFloat(previousSelling) != parseFloat(valSelling)) {
                            setAlertDescription("Do you want to change selling price location wise ?")
                            setAlertConfirmOption(13)
                            setsweetAlertShow(true)
                          }





                        }}
                        Gen_SellingPrice_Enabled={blSellingEnable}
                        Gen_PackPrice={dbPackPrice}
                        Gen_PackPrice_OnChange={e => {
                          let valPack = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valPack == "") {
                            SetPackPrice("0.0")
                          }
                          else {
                            SetPackPrice(valPack)
                          }
                        }}
                        Gen_PackPrice_onBlur={e => {
                          let valPack = DecimalValidation(e.target.value, 0, true, txnDecimalAmt)
                          SetPackPrice(valPack)
                        }}
                        Gen_PackPrice_Enabled={blPackPriceEnable}
                        Gen_AvgCost={dbAVGCost}
                        Gen_AvgCost_OnChange={e => {
                          let valAVGCost = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valAVGCost == "") {
                            SetAVGCost("0.0")
                          }
                          else {
                            SetAVGCost(valAVGCost)
                          }
                        }}
                        Gen_AvgCost_Enabled={blAVGCostEnable}
                        Gen_FixedGP={dbFixedGP}
                        Gen_FixedGP_OnChange={e => {
                          let valFixedGP = Numeric(e.target, 15, 2, false)
                          if (valFixedGP == "") {
                            SetFixedGP("0.0")
                          }
                          else {
                            SetFixedGP(valFixedGP)
                          }
                        }}
                        Gen_FixedGP_onBlur={e => {
                          let valFixedGP = DecimalValidation(e.target.value, 0, true, 2)
                          SetFixedGP(valFixedGP)
                        }}
                        Gen_FixedGP_Enabled={blFixedGPEnable}
                        Gen_CurrentGP={dbCurrGP}
                        Gen_CurrentGP_OnChange={e => {

                          let valCurrentGP = Numeric(e.target, 15, 2, false)
                          if (valCurrentGP == "") {
                            SetCurrGP("0.0")
                          }
                          else {
                            SetCurrGP(valCurrentGP)
                          }

                        }}
                        Gen_CurrentGP_Enabled={blCurrGPEnable}
                        Gen_MaxDis={dbMaxDicPer}
                        Gen_MaxDis_OnChange={e => {
                          let valMaxDis = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valMaxDis == "") {
                            SetMaxDicPer(0.0)
                          }
                          else {
                            SetMaxDicPer(valMaxDis)

                          }
                        }}
                        Gen_MaxDis_onBlur={e => {
                          let valMaxDis = DecimalValidation(e.target.value)
                          if (valMaxDis <= 100) {
                            SetMaxDicPer(valMaxDis)
                          } else {
                            SetMaxDicPer(0.0)
                          }
                        }}
                        Gen_MaxDis_Enabled={blMaxDicPerEnable}
                        Gen_MaxDisAmt={dbrMaxDicAmt}

                        Gen_MaxDisAmt_OnChange={e => {
                          let valMaxDisamt = Numeric(e.target, 15, txnDecimalAmt, false)
                          if (valMaxDisamt == "") {
                            SetMaxDicAmt(0.0)

                          }
                          else {
                            SetMaxDicAmt(e.target.value)
                          }


                        }}
                        Gen_MaxDisAmt_onBlur={e => {
                          let valMaxDisamt = DecimalValidation(e.target.value, 0, true, txnDecimalAmt)
                          if (valMaxDisamt < parseFloat(dbSelling, 10)) {
                            SetMaxDicAmt(valMaxDisamt)
                          } else {
                            SetMaxDicAmt(0.0)

                          }
                        }}
                        Gen_MaxDisAmt_Enabled={blMaxDicAmtEnable}
                        Gen_MaxAllowQty={dbrMaxAllowQty}

                        Gen_MaxAllowQty_OnChange={e => {
                          let valAllowQty = Numeric(e.target, 8, txnDecimalQty, false)
                          if (valAllowQty == "") {
                            SetMaxAllowQty("0.0")
                          }
                          else {
                            SetMaxAllowQty(valAllowQty)
                          }

                        }}
                        Gen_MaxAllowQty_onBlur={e => {
                          let valAllowQty = DecimalValidation(e.target.value, 0, true, txnDecimalQty)
                          SetMaxAllowQty(valAllowQty)

                        }}
                        Gen_MaxAllowQty_Enabled={blMaxAllowQtyEnable}
                        Unit={strUnit}
                        Gen_Unit={e => {
                          SetUnit(e["value"])
                        }}

                        Gen_Unit_Enabled={blUnitEnable}
                        PurchasingMode={strPurchase}
                        Gen_PurchasingMode={e => {
                          SetPurchase(e["value"])
                        }}
                        Gen_PurchasingMode_Enabled={blPurchaseEnable}
                        Language1={strLanguage1}
                        Gen_Language1={e => {
                          let valLanguage1 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLanguage1(valLanguage1)
                        }}

                        Gen_Language1_Enabled={blLanguage1Enable}
                        Language2={strLanguage2}
                        Gen_Language2={e => {
                          let valLanguage2 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetLanguage2(valLanguage2)
                        }}

                        Gen_Language2_Enabled={blLanguage2Enable}
                        AlertColor={AlertColor}
                        AlertMsg={AlertMsg}
                        AlertShow={AlertShow}
                        onButtonClick={e => {

                          setCodeButton(true)
                          getAutoCodeFromAPI(menuCode)
                        }}
                        btnDisable={codeButton}
                        SearchDisable={searchdisabled}
                        showFileUpload={(e) => {
                          const file = e.target.files[0];
                          setFile(file)
                        }}
                        valueUpload={valueUpload}
                        setVenderPLU={e => {

                          if (strVendorPLU != "") {

                            if (strVendorPLU != strReference1 && strVendorPLU != strReference2 && strVendorPLU != strReference3 && strVendorPLU != strReference4 && strVendorPLU != strReference5) {
                              if (strReference1 == "") {
                                SetReference1(strVendorPLU)
                              } else if (strReference2 == "") {
                                SetReference2(strVendorPLU)
                              } else if (strReference3 == "") {
                                SetReference3(strVendorPLU)
                              } else if (strReference4 == "") {
                                SetReference4(strVendorPLU)
                              } else if (strReference5 == "") {
                                SetReference5(strVendorPLU)
                              } else {
                                displayAlertMessage('danger', "All the Reference field are full")
                                return

                              }
                            } else {
                              displayAlertMessage('danger', "This is already in References")
                              return

                            }
                          } else {
                            displayAlertMessage('danger', "Please Enter Vendor PLU")
                            return
                          }

                        }}
                        imagesrc={picture.imageSrc}
                        proDescEnable={proDescEnable}

                        proPosDescDisable={proPosDescDisable}
                        proTouchDescDisable={proTouchDescDisable}
                        proStockDisable={proStockDisable}
                        proVendorDisable={proVendorDisable}
                        ProUnitDisable={ProUnitDisable}
                        ProPurModeDisable={ProPurModeDisable}
                        ProCSDisable={ProCSDisable}
                        ProCostDisable={ProCostDisable}
                        ProMarkupDisable={ProMarkupDisable}
                        ProSellDisable={ProSellDisable}
                        ProPackDisable={ProPackDisable}
                        ProAVGDisable={ProAVGDisable}
                        ProFixGPDisable={ProFixGPDisable}
                        ProGPDisable={ProGPDisable}
                        ProMaxDiscDisable={ProMaxDiscDisable}
                        ProMaxDiscAmtDisable={ProMaxDiscAmtDisable}
                        ProMaxAllowQtyDisable={ProMaxAllowQtyDisable}
                        ProPictureDisable={ProPictureDisable}
                        ProLan1Disable={ProLan1Disable}
                        ProLan2Disable={ProLan2Disable}
                        ProReturnDisable={ProReturnDisable}
                        autoCode={autoCode}
                        AddNew={AddNew}
                        Tab1Create={Tab1Create}
                        Tab1Modify={Tab1Modify}

                        // Return /Empty Botle
                        Return_Code={strReturnCode}
                        Return_DataSearch={async () => {
                          return_tog_xlarge()
                        }}
                        Return_Code_onKeyPress={e => {
                          if (e.charCode == 13) {
                            ReturnValueSetter(strReturnCode)
                          }
                        }}
                        Return_Code_onBlur={e => {
                          ReturnValueSetter(e.target.value)
                        }}
                        Return_Code_OnChange={e => {
                          let valCode = Text(
                            e.target,
                            25,
                            true,
                            true,
                            "upper",
                            false
                          )
                          setReturnDescription('')
                          setReturnCode(valCode)
                        }}
                        Return_Description={strReturnDescription}
                        Return_CodeSearchOpen={return_modal_xlarge}
                        GetSelectReturnRow={Return_SelectRowSearch}
                        Return_CodeSearchTrigger={return_tog_xlarge}
                        hideFields={hideFields}
                        dbMinSell={dbMinSell}
                        ProMinSellDisable={ProMinSellDisable}
                        Gen_SetMinSell_OnChange={e => {
                          let valAllowQty = Numeric(e.target, 8, 2, false)
                          if (valAllowQty == "") {
                            SetMinSell("0.0")
                          }
                          else {
                            SetMinSell(valAllowQty)
                          }

                        }}
                        Gen_SetMinSell_onBlur={e => {
                          let valAllowQty = DecimalValidation(e.target.value, 0, true, 2)
                          SetMinSell(valAllowQty)

                        }}
                        is_IR_user={is_IR_user}
                        logLocation={LocationCode}
                        proFormData={proFormData}
                        setProFormData={setProFormData}
                        shortExpieryDisable={!blExpiry}
                        shortExpieryHide={shortExpieryDisable}
                      ></ProductGenContent>
                    </TabPane>
                    <TabPane tabId="2">
                      <ProductStatusContent
                        Status_PosActive_Enable={blPosActiveEnable}
                        Status_PosActive={blPosActive}
                        Status_PosActive_OnChnage={() => {
                          SetPosActive(!blPosActive)
                        }}
                        Status_Active={blActive}
                        Status_Active_OnChange={() => {
                          SetActive(!blActive)
                        }}
                        Status_Active_Enabled={blActiveEnable}
                        Status_Purchase={backofficeActive}
                        Status_Purchase_OnChange={() => {
                          SetBackOfficeActive(!backofficeActive)
                        }}
                        Status_Purchase_Enabled={blPurOrderEnable}
                        Status_Open={blOpen}
                        Status_Open_OnChange={() => {
                          SetOpen(!blOpen)
                        }}
                        Status_Open_Enabled={blOpenEnable}
                        Status_Composite={blComposite}
                        Status_Composite_OnChange={() => {
                          SetComposite(!blComposite)
                        }}
                        Status_Composite_Enabled={blCompositeEnable}
                        Status_Weighted={blWeighted}
                        Status_Weighted_OnChange={(e) => {

                          if (validateWeighted_VS_MP == 1 && e) {
                            SetMultiplePrices(false)
                          }

                          SetWeighted(e)

                        }}
                        Status_Weighted_Enabled={blWeightedEnable}
                        Status_Expiry={blExpiry}
                        Status_Expiry_OnChange={() => {
                          SetExpiry(!blExpiry)
                        }}
                        Status_Expiry_Enabled={blExpiryEnable}
                        Status_DirectGRN={blDirectGRN}
                        Status_DirectGRN_OnChange={() => {
                          SetDirectGRN(!blDirectGRN)
                        }}
                        Status_DirectGRN_Enabled={blDirectGRNEnable}
                        Status_MPrices={blMultiplePrices}
                        Status_MPrices_OnChange={(e) => {

                          if (validateWeighted_VS_MP == 1 && e) {
                            SetWeighted(false)
                          }

                          SetMultiplePrices(e)

                        }}
                        Status_MPrices_Enabled={blMultiplePricesEnable}
                        Status_priceHO={blSellingHo}
                        Status_priceHO_OnChange={() => {
                          SetSellingHo(!blSellingHo)
                        }}
                        Status_priceHO_Enabled={blSellingHoEnable}
                        Status_FastMoving={blfastmoving}
                        Status_FastMoving_OnChange={() => {
                          Setfastmoving(!blfastmoving)
                        }}
                        Status_FastMoving_Enabled={blfastmovingEnable}
                        Status_RawItem={blRaw}
                        Status_RawItem_OnChange={() => {
                          SetRaw(!blRaw)
                        }}
                        Status_RawItem_Enabled={blRawEnable}
                        Status_Discounts={blPromotions}
                        Status_Discounts_OnChange={() => {
                          SetPromotions(!blPromotions)
                        }}
                        Status_Discounts_Enabled={blPromotionsEnable}
                        Status_Minus_OnChange={() => {
                          SetminusAllow(!minusAllow)
                        }}
                        Status_Minus={minusAllow}
                        Status_Minus_Enabled={blExpiryEnable}
                        Batch_enable={batchEnable}
                        Batch_OnChange={() => {
                          SetbatchEnable(!batchEnable)
                        }}
                        Varient_Enable={varientEnable}
                        Varient_OnChange={() => {
                          SetvarientEnable(!varientEnable)
                        }}
                        showBatch={showBatch}
                        showVarient={showVarient}

                        Exchange_Enable={allowExchange}
                        Exchange_OnChange={() => {
                          SetAllowExchange(!allowExchange);
                        }}

                        ProActiveDisable={ProActiveDisable}
                        ProPosActiveDisable={ProPosActiveDisable}
                        ProOrderActiveDisable={ProOrderActiveDisable}
                        ProOpenDisable={ProOpenDisable}
                        ProBundleDisable={ProBundleDisable}
                        ProDecimalDisable={ProDecimalDisable}
                        ProExpDisable={ProExpDisable}
                        ProDIRGRNDisable={ProDIRGRNDisable}
                        ProHOPriceDisable={ProHOPriceDisable}
                        ProFastMoveDisable={ProFastMoveDisable}
                        ProRawItemDisable={ProRawItemDisable}
                        ProNoDiscDisable={ProNoDiscDisable}
                        ProMPDisable={ProMPDisable}
                        ProMinusDisable={ProMinusDisable}
                        ProAllowQTYDisable={ProAllowQTYDisable}
                        ProAllowExchange={ProAllowExchange}
                        Tab2Create={Tab2Create}
                        Tab2Modify={Tab2Modify}
                        AddNew={AddNew}
                        hideFields={hideFields}
                        emptyBottle={emptyBottle}
                        emptyBottleOnchange={() => {
                          setEmptyBottle(!emptyBottle)
                        }}
                        emptyBottleDisable={emptyBottleDisable}
                        emptyBottleEnable={emptyBottleEnable}
                        productionPOS={productionPOS}
                        productionPOSOnchange={() => {
                          setProductionPOS(!productionPOS)
                        }}
                        productionPOSDisable={productionPOSDisable}
                        allowCostZero={allowCostZero}
                        allowCostZeroOnchange={() => {
                          setAllowCostZero(!allowCostZero)
                        }}
                        allowCostZeroDisable={allowCostZeroDisable}
                        isCombineItem={isCombineItem}
                        setIsCombineItem={() => {
                          setIsCombineItem(!isCombineItem)
                        }}
                        isCombineItemDisable={isCombineItemDisable}

                      ></ProductStatusContent>
                    </TabPane>
                    <TabPane tabId="3">
                      <ProductRefContent
                        Ref_Reference1={strReference1}
                        Ref_Reference1_OnChange={e => {
                          let valRef1 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetReference1(valRef1)
                        }}
                        Ref_Reference1_Enabled={blReference1Enable ? true : AddNew && Tab3Create ? ProRef1Disable ? true : false : AddNew == false && Tab3Modify ? ProRef1Disable ? true : false : true}
                        Ref_Reference2={strReference2}
                        Ref_Reference2_OnChange={e => {
                          let valRef2 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetReference2(valRef2)
                        }}
                        Ref_Reference2_Enabled={blReference2Enable ? true : AddNew && Tab3Create ? ProRef2Disable ? true : false : AddNew == false && Tab3Modify ? ProRef2Disable ? true : false : true}
                        Ref_Reference3={strReference3}
                        Ref_Reference3_OnChange={e => {
                          let valRef3 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetReference3(valRef3)
                        }}
                        Ref_Reference3_Enabled={blReference3Enable ? true : AddNew && Tab3Create ? ProRef3Disable ? true : false : AddNew == false && Tab3Modify ? ProRef3Disable ? true : false : true}
                        Ref_Reference4={strReference4}
                        Ref_Reference4_OnChange={e => {
                          let valRef4 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetReference4(valRef4)
                        }}
                        Ref_Reference4_Enabled={blReference4Enable ? true : AddNew && Tab4Create ? ProRef4Disable ? true : false : AddNew == false && Tab3Modify ? ProRef4Disable ? true : false : true}
                        Ref_Reference5={strReference5}
                        Ref_Reference5_OnChange={e => {
                          let valRef5 = Text(
                            e.target,
                            100,
                            true,
                            true,
                            "any",
                            true
                          )
                          SetReference5(valRef5)
                        }}
                        Ref_Reference5_Enabled={blReference5Enable ? true : AddNew && Tab3Create ? ProRef5Disable ? true : false : AddNew == false && Tab3Modify ? ProRef5Disable ? true : false : true}
                        innerCaseSizes={innerCaseSizes}
                        setInnerCaseSizes={setInnerCaseSizes}
                        disabled={disabled}
                        HandleClearStatus={handleClearStatus}
                      ></ProductRefContent>
                    </TabPane>
                    <TabPane tabId="4">
                      <ProductGroupContent
                        Disabled={disabled ? true : AddNew && Tab4Create ? false : AddNew == false && Tab4Modify ? false : true}
                        DataRow={optionGroup}
                        setoptionGroup1={setoptionGroup1}
                        menuCode={menuCode}
                        Tab4Create={Tab4Create}
                        Tab4Modify={Tab4Modify}
                        AddNew={AddNew}
                        GroupsDisable={GroupsDisable}
                        handleClearStatus={handleClearStatus}
                      ></ProductGroupContent>
                    </TabPane>
                    <TabPane tabId="5">
                      <ProductSupplierContent
                        DataRow={arRowSup}
                        setarRowSupp={setarRowSupp}
                        RemoveRow={handleRemoveRowSupp}
                        AddRow={handleAddRowNestedSupp}
                        Disabled={disabled ? true : AddNew && Tab5Create ? false : AddNew == false && Tab5Modify ? false : true}
                        menuCode={menuCode}
                        handleClearStatus={handleClearStatus}
                        SetLoadingAlert={SetLoadingAlert}
                        SetLoadingAlerttitle={SetLoadingAlerttitle}
                      ></ProductSupplierContent>
                    </TabPane>
                    <TabPane tabId="6"  >
                      <ProductInventoryContent
                        Disabled={disabled ? true : AddNew && Tab6Create ? false : AddNew == false && Tab6Modify ? false : true}
                        DataRow={ProInventory}
                        SetData={setoInventory}
                        Show={inventoryShow}
                        setInventoryShow={setInventoryShow}
                        AddNew={AddNew}
                        CostPrice={dbCost}
                        AVGPrice={dbAVGCost}
                        SellingPrice={dbSelling}
                        menuCode={menuCode}
                        handleClearStatus={handleClearStatus}
                        blActive={blActive}
                        refreshSIH={refreshSIH}
                        showBatch={showBatch}
                        showVarient={showVarient}
                      ></ProductInventoryContent>
                    </TabPane>
                    <TabPane tabId="7">
                      <ProductBarcodeContent
                        DataRow={arRowBarcode}
                        setarRowBarcode={setarRowBarcode}
                        RemoveRow={handleRemoveRowBarcode}
                        AddRow={handleAddRowNestedBarcode}
                        Disabled={disabled ? true : AddNew && Tab7Create ? false : AddNew == false && Tab7Modify ? false : true}
                        menuCode={menuCode}
                        handleClearStatus={handleClearStatus}
                      ></ProductBarcodeContent>
                    </TabPane>
                    <TabPane tabId="8">
                      <ProductTaxContent
                        DataRow={arRow}
                        setarRow={setarRow}
                        RemoveRow={handleRemoveRow}
                        AddRow={handleAddRowNested}
                        Disabled={disabled ? true : AddNew && Tab8Create ? false : AddNew == false && Tab8Modify ? false : true}
                        menuCode={menuCode}
                      ></ProductTaxContent>
                    </TabPane>
                    <TabPane tabId="9">
                      <ProductPriceContent
                        DataRow={arRowPrice}
                        setarRowPrice={setarRowPrice}
                        RemoveRow={handleRemoveRowprice}
                        AddRow={handleAddRowNestedPrice}
                        Disabled={disabled ? true : AddNew && Tab9Create ? false : AddNew == false && Tab9Modify ? false : true}
                        menuCode={menuCode}
                        handleClearStatus={handleClearStatus}
                        locationPriceForm={locationPriceForm}
                        setLocationPriceForm={setLocationPriceForm}
                      ></ProductPriceContent>
                    </TabPane>
                    <TabPane tabId="10">
                      <ProductImageContent
                        Disabled={disabled ? true : AddNew && Tab10Create ? false : AddNew == false && Tab10Modify ? false : true}
                        imagesrc={picture.imageSrc}
                        ShowPreview={e => {

                          if (e.target.files && e.target.files[0]) {
                            let imageFile = e.target.files[0];
                            const reader = new FileReader();
                            reader.onload = x => {
                              setPicture({
                                imageFile,
                                imageSrc: x.target.result,
                                imagepath: e.target.value
                              })
                            }
                            reader.readAsDataURL(imageFile)
                          }
                          else {
                            setPicture({
                              imageFile: null,
                              imageSrc: Noimage,
                              imagepath: null
                            })
                          }
                        }}
                        setPicture={setPicture}
                        RemoveImage={RemoveImage}
                      ></ProductImageContent>
                    </TabPane>
                    <TabPane tabId="11">
                      {varientEnable ? <ProductVarientContent
                        autoCode={autoCode}
                        strProductCode={strProductCode}
                        dbCost={dbCost}
                        dbAVGCost={dbAVGCost}
                        strProductDesc={strProductDesc}
                        setAlertColor={setAlertColor}
                        setAlertMsg={setAlertMsg}
                        setAlertShow={setAlertShow}
                        varient2apply={varient2apply}
                        setVarient2apply={setVarient2apply}
                        varient1apply={varient1apply}
                        setVarient1apply={setVarient1apply}
                        setMergerItems={setMergerItems}
                        mergerItems={mergerItems}
                        allSizes={allSizes}
                        setAllSizes={setAllSizes}
                        setAllColors={setAllColors}
                        allColors={allColors}
                        getAllColors={getAllColors}
                        getAllSizes={getAllSizes}
                        dbSelling={dbSelling}
                        Disabled={disabled ? true : AddNew && Tab11Create ? false : AddNew == false && Tab11Modify ? false : true}
                        variant1name={variant1name}
                        variant2name={variant2name}
                        setVariantPNG={(e) => {
                          setVariantPNG(e["value"])
                          setPNGPath(ReportURL + e["value"])

                        }}
                        PNGPath={PNGPath}
                        variantPNG={variantPNG}
                        linkName={linkName}
                      /> : null}
                    </TabPane>
                    <TabPane tabId="12">
                      <ProductAutoOrderContent
                        Disabled={disabled ? true : AddNew && Tab12Create ? false : AddNew == false && Tab12Modify ? false : true}
                        HandleClearStatus={handleClearStatus}
                        productCode={strProductCode}
                        productDesc={strProductDesc}
                        costPrice={dbCost}
                        salesPrice={dbSelling}
                        packSize={strCasesize}
                        supplier={arRowSup}
                        setAlertShow={setAlertShow}
                        setAlertColor={setAlertColor}
                        setAlertMsg={setAlertMsg}
                      />
                    </TabPane>

                    <TabPane tabId="13">
                      <ProductPriceChanges
                        multiplePriceList={multiplePriceList}
                        RemovePrice={RemovePrice}
                        Disabled={disabled ? true : AddNew && Tab13Create ? false : AddNew == false && Tab13Modify ? false : true}
                      />
                    </TabPane>

                    <TabPane tabId="14">
                      <ProductSupplierFreeQty
                        freeQtyList={freeQtyList}
                        setFreeQtyList={setFreeQtyList}
                        Disabled={disabled}
                        menuCode={menuCode}
                      />
                    </TabPane>

                    <TabPane tabId="15">
                      <ProductDefaultLocation
                        defaultLocations={defaultLocations}
                        setDefaultLocations={setDefaultLocations}
                        handleClearStatus={handleClearStatus}
                        Disabled={disabled}

                      />
                    </TabPane>


                  </TabContent>
                  <Row>
                    {LogEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01T00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdDate}
                        modifiedOn={mdBy != '1900-01-01T00:00:00' ? (mdBy) ? mdBy.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                    <DPSearchBox
                      searchData={[]}
                      columns={columns}
                      defaultSorted={defaultSorted}
                      mainTitle={"Excel Import Result"}
                      SubTitle={""}
                      Details={"If one or more record status failed ! then please correct all dataset and upload again."}
                      SelectType={'radio'}//checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                      isOpen={excelResult}
                      toggle={excelTrigger}
                    />
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ProductMaster


